// client/src/data/lessonMeta.js
export const lessonMeta = {
  beginner: {
    1: {
      title: "Talk About Yourself",
      outcome: "You can introduce yourself with your name, role, and place.",
      tamilOutcome:
        "நீங்கள் உங்கள் பெயர், வேலை, இடம் சேர்த்து உங்களை அறிமுகப்படுத்த முடியும்.",
      patterns: ["My name is...", "I am...", "I am from..."],
      video: {
        provider: "vimeo",
        id: "1194920934",
        ratio: "9:16",
      },
    },
    2: {
      title: "Talk About Your Daily Routine",
      outcome: "You can speak about your daily routine clearly.",
      tamilOutcome: "நீங்கள் உங்கள் தினசரி வழக்கத்தை தெளிவாக பேச முடியும்.",
      patterns: ["I wake up...", "I go...", "I work..."],
      video: {
        provider: "vimeo",
        id: "1194920950",
        ratio: "9:16",
      },
    },
    3: {
      title: "Create 1000s of Sentences",
      outcome: "You can say your wants, needs, and likes confidently.",
      tamilOutcome:
        "நீங்கள் உங்கள் விருப்பம், தேவை, பிடித்தவை பற்றி நம்பிக்கையுடன் சொல்ல முடியும்.",
      patterns: ["I want...", "I need...", "I like..."],
      video: {
        provider: "vimeo",
        id: "1194920983",
        ratio: "9:16",
      },
    },
    4: {
      title: "Say Who You Are Professionally",
      outcome: "You can talk about your job or role in simple English.",
      tamilOutcome:
        "நீங்கள் உங்கள் வேலை அல்லது பொறுப்பை எளிய ஆங்கிலத்தில் சொல்ல முடியும்.",
      patterns: ["I am a...", "I am an...", "I’m a..."],
      video: {
        provider: "vimeo",
        id: "1194920998",
        ratio: "9:16",
      },
    },
    5: {
      title: "Talk About Your Friends & Team",
      outcome: "You can talk about people, groups, and teams.",
      tamilOutcome:
        "நீங்கள் நண்பர்கள், மனிதர்கள், குழுக்கள், பற்றி பேச முடியும்.",
      patterns: ["You are...", "We are...", "They are..."],
      video: {
        provider: "vimeo",
        id: "1194920999",
        ratio: "9:16",
      },
    },
    6: {
      title: "Introduce Friends, Colleagues and Companies",
      outcome: "You can introduce another person or company.",
      tamilOutcome:
        "நீங்கள் மற்றொருவரையோ நிறுவனத்தையோ அறிமுகப்படுத்த முடியும்.",
      patterns: ["He is...", "She is...", "It is..."],
      video: {
        provider: "vimeo",
        id: "1194923920",
        ratio: "9:16",
      },
    },
    7: {
      title: "Correct Wrong Information Politely",
      outcome: "You can say what is not true and correct it politely.",
      tamilOutcome: "நீங்கள் தவறான தகவலை மரியாதையாக திருத்தி சொல்ல முடியும்.",
      patterns: ["I am not...", "I’m not a...", "Actually, I am..."],
      video: {
        provider: "vimeo",
        id: "1194923941",
        ratio: "9:16",
      },
    },
    8: {
      title: "Ask About Roles and People",
      outcome: "You can ask simple identity questions about people.",
      tamilOutcome:
        "நீங்கள் மனிதர்கள் பற்றி எளிய அடையாள கேள்விகள் கேட்க முடியும்.",
      patterns: ["Are you...?", "Who is he?", "Who is she?"],
      video: {
        provider: "vimeo",
        id: "1194923975",
        ratio: "9:16",
      },
    },
    9: {
      title: "Speak Naturally With Short Forms",
      outcome: "You can use short forms and sound more natural.",
      tamilOutcome:
        "நீங்கள் short forms பயன்படுத்தி இன்னும் இயல்பாக பேச முடியும்.",
      patterns: ["I’m...", "You’re...", "They’re..."],
      video: {
        provider: "vimeo",
        id: "1194923992",
        ratio: "9:16",
      },
    },
    10: {
      title: "Professional Self-Introduction Challenge",
      outcome:
        "You can introduce yourself confidently in real-life situations.",
      tamilOutcome: "உங்களை தன்னம்பிக்கையுடன் அறிமுகப்படுத்த முடியும்.",
      patterns: ["I’m here for...", "My name is...", "I work as..."],
      video: {
        provider: "vimeo",
        id: "1194924010",
        ratio: "9:16",
      },
    },
    11: {
      title: "Talk About Work Preferences",
      outcome: "You can say what you like at work.",
      tamilOutcome: "வேலை இடத்தில் உங்களுக்கு பிடித்ததை சொல்ல முடியும்.",
      patterns: ["I like...", "I like working...", "I like using..."],
      video: {
        provider: "vimeo",
        id: "1189314375",
        ratio: "9:16",
      },
    },
    12: {
      title: "Talk About other people's Routine",
      outcome: "You can speak about what another person does.",
      tamilOutcome: "நீங்கள் மற்றொருவர் என்ன செய்கிறார் என்று சொல்ல முடியும்.",
      patterns: ["He likes...", "She works...", "He uses..."],
      video: {
        provider: "vimeo",
        id: "1192998492",
        ratio: "9:16",
      },
    },
    13: {
      title: "Talk About Food and Drinks",
      outcome: "You can speak about eating, drinking, and office breaks.",
      tamilOutcome: "உணவு, பானம், இடைவேளை பற்றி பேச முடியும்.",
      patterns: ["I eat...", "I drink...", "I have..."],
      video: {
        provider: "vimeo",
        id: "1192998909",
        ratio: "9:16",
      },
    },
    14: {
      title: "Say What You Don’t Do",
      outcome: "You can say what you or others don’t do.",
      tamilOutcome: "நீங்கள் அல்லது மற்றவர்கள் செய்யாததை சொல்ல முடியும்.",
      patterns: ["I don’t...", "He doesn’t...", "She doesn’t..."],
      video: {
        provider: "vimeo",
        id: "1192998988",
        ratio: "9:16",
      },
    },
    15: {
      title: "Ask Simple Work Questions",
      outcome: "You can ask simple questions about work habits.",
      tamilOutcome: "வேலை பழக்கங்கள் பற்றி எளிய கேள்விகள் கேட்க முடியும்.",
      patterns: ["Do you...?", "Do you work...?", "Do you use...?"],
      video: {
        provider: "vimeo",
        id: "1192999024",
        ratio: "9:16",
      },
    },
    16: {
      title: "Describe Your Workday",
      outcome: "You can talk about your daily work routine.",
      tamilOutcome: "உங்கள் தினசரிவழக்கத்தை சொல்ல முடியும்.",
      patterns: [
        "I wake up at...",
        "I start work at...",
        "I finish work at...",
      ],
      video: {
        provider: "vimeo",
        id: "1193144204",
        ratio: "9:16",
      },
    },
    17: {
      title: "Talk About Habits and Reliability",
      outcome: "You can say how often you do something.",
      tamilOutcome: "உங்கள் பழக்கவழக்கங்களைப் பற்றி பேச முடியும்.",
      patterns: ["I always...", "I never...", "I usually..."],
      video: {
        provider: "vimeo",
        id: "1193144328",
        ratio: "9:16",
      },
    },
    18: {
      title: "Order Coffee Politely",
      outcome: "You can order coffee or snacks in a polite way.",
      tamilOutcome: "காபி அல்லது சிற்றுண்டியை ஆர்டர் செய்வது எப்படி?",
      patterns: ["I want...", "I’d like...", "Can I have...?"],
      video: {
        provider: "vimeo",
        id: "1193144367",
        ratio: "9:16",
      },
    },
    19: {
      title: "Describe a Busy Workday",
      outcome: "You can speak about a busy day using longer sentences.",
      tamilOutcome:
        "பிஸியான நாளைப் பற்றி நீளமான வாக்கியங்களில் செய்வது எப்படி?",
      patterns: ["I wake up at...", "I always...", "After work..."],
      video: {
        provider: "vimeo",
        id: "1193144413",
        ratio: "9:16",
      },
    },
    20: {
      title: "Explain Your Daily Routine",
      outcome: "You can explain your full workday routine in English.",
      tamilOutcome: "உங்கள் முழு நாள் வழக்கத்தை ஆங்கிலத்தில் விளக்க முடியும்.",
      patterns: ["I start work at...", "I usually...", "I finish work at..."],
      video: {
        provider: "vimeo",
        id: "1193144469",
        ratio: "9:16",
      },
    },
    21: {
      title: "Talk About Tools and Resources",
      outcome: "You can say what tools and resources you have.",
      tamilOutcome:
        "உங்களிடம் உள்ள கருவிகள் மற்றும் வசதிகள் பற்றி எப்படி சொல்வது?",
      patterns: ["I have...", "I have a...", "I have some..."],
      video: {
        provider: "vimeo",
        id: "1193144536",
        ratio: "9:16",
      },
    },
    22: {
      title: "Describe What Others Have",
      outcome: "You can say what another person has.",
      tamilOutcome: "மற்றொருவரிடம் என்ன உள்ளது என்பதை எப்படி சொல்வது?",
      patterns: ["He has...", "She has...", "It has..."],
      video: {
        provider: "vimeo",
        id: "1193146317",
        ratio: "9:16",
      },
    },
    23: {
      title: "Locate Office Items",
      outcome: "You can say where items are.",
      tamilOutcome: "பொருட்கள் எங்கு உள்ளன என்பதை எப்படி சொல்வது?",
      patterns: ["It is in...", "It is on...", "It is under..."],
      video: {
        provider: "vimeo",
        id: "1193146337",
        ratio: "9:16",
      },
    },
    24: {
      title: "Give Simple Location Details",
      outcome: "You can describe where something is placed.",
      tamilOutcome: "ஒரு பொருள் எங்கு வைக்கப்பட்டுள்ளது என்பதை எப்படி சொல்வது?",
      patterns: ["It is next to...", "It is behind...", "It is near..."],
      video: {
        provider: "vimeo",
        id: "1193146361",
        ratio: "9:16",
      },
    },
    25: {
      title: "Refer to Documents and Objects",
      outcome: "You can point to one thing and talk about it.",
      tamilOutcome: "ஒரு பொருளைக் காட்டி அதைப் பற்றி எப்படி பேசுவது?",
      patterns: ["This is...", "That is...", "This document is..."],
      video: {
        provider: "vimeo",
        id: "1193146412",
        ratio: "9:16",
      },
    },
    26: {
      title: "Talk About Files and Products",
      outcome: "You can talk about many things near or far.",
      tamilOutcome:
        "அருகில் அல்லது தொலைவில் உள்ள பல பொருட்கள் பற்றி எப்படி பேசுவது?",
      patterns: ["These are...", "Those are...", "These files are..."],
      video: {
        provider: "vimeo",
        id: "1193148681",
        ratio: "9:16",
      },
    },
    27: {
      title: "Ask About Ownership",
      outcome: "You can ask who owns something.",
      tamilOutcome: "ஒரு பொருள் யாருடையது என்று எப்படி கேட்பது?",
      patterns: ["Whose is this?", "Whose file is this?", "It is Ram’s..."],
      video: {
        provider: "vimeo",
        id: "1193148751",
        ratio: "9:16",
      },
    },
    28: {
      title: "Find Lost Items",
      outcome: "You can describe and ask about lost items.",
      tamilOutcome: "காணாமல் போன பொருட்களை எப்படி விவரித்து கேட்பது",
      patterns: ["I lost...", "It is a...", "Have you seen...?"],
      video: {
        provider: "vimeo",
        id: "1193148812",
        ratio: "9:16",
      },
    },
    29: {
      title: "Describe Your Desk or Office Setup",
      outcome: "You can describe your workspace clearly.",
      tamilOutcome: "நீங்கள் உங்கள் வேலை இடத்தை தெளிவாக விவரிப்பது எப்படி?",
      patterns: ["On my desk...", "Next to my...", "Behind the..."],
      video: {
        provider: "vimeo",
        id: "1193148874",
        ratio: "9:16",
      },
    },
    30: {
      title: "Explain Your Workspace Clearly",
      outcome: "You can talk about your desk, tools, and office items.",
      tamilOutcome:
        "நீங்கள் உங்கள் மேசை, கருவிகள், அலுவலக பொருட்கள் பற்றி தெளிவாக பேசுவது எப்படி?",
      patterns: ["I have...", "It is on...", "These are..."],
      video: {
        provider: "vimeo",
        id: "1193148903",
        ratio: "9:16",
      },
    },
    31: {
      title: "Describe Products and Designs",
      outcome:
        "You can describe products, documents, and designs using colors and shapes.",
      tamilOutcome:
        "நீங்கள் நிறம் மற்றும் வடிவம் பயன்படுத்தி பொருட்கள், ஆவணங்கள், டிசைன்களை விவரிக்க முடியும்.",
      patterns: ["The red...", "It is round.", "This design is..."],
      video: {
        provider: "vimeo",
        id: "1193156682",
        ratio: "9:16",
      },
    },
    32: {
      title: "Talk About People and Relationships",
      outcome: "You can talk about family and relationships politely.",
      tamilOutcome:
        "நீங்கள் குடும்பம் மற்றும் உறவுகள் பற்றி மரியாதையாக பேச முடியும்.",
      patterns: ["My father is...", "My mother is...", "He is my..."],
      video: {
        provider: "vimeo",
        id: "1193157311",
        ratio: "9:16",
      },
    },
    33: {
      title: "Describe Size and Quality",
      outcome: "You can describe size, quality, and simple business needs.",
      tamilOutcome:
        "நீங்கள் அளவு, தரம், வணிகத் தேவைகள் பற்றி எளிதாக சொல்ல முடியும்.",
      patterns: ["It is big.", "It is small.", "We need a..."],
      video: {
        provider: "vimeo",
        id: "1193157351",
        ratio: "9:16",
      },
    },
    34: {
      title: "Express Work Feelings Professionally",
      outcome: "You can say how you feel at work in a simple way.",
      tamilOutcome:
        "நீங்கள் வேலை இடத்தில் எப்படி உணர்கிறீர்கள் என்று எளிதாக சொல்ல முடியும்.",
      patterns: ["I am excited.", "I feel tired.", "I am worried about..."],
      video: {
        provider: "vimeo",
        id: "1193157405",
        ratio: "9:16",
      },
    },
    35: {
      title: "Describe People Politely",
      outcome: "You can describe a person’s appearance carefully.",
      tamilOutcome: "நீங்கள் ஒருவரின் தோற்றத்தை மரியாதையாக விவரிக்க முடியும்.",
      patterns: ["He has...", "She has...", "He looks..."],
      video: {
        provider: "vimeo",
        id: "1193157467",
        ratio: "9:16",
      },
    },
    36: {
      title: "Emphasize Ideas Naturally",
      outcome: "You can make your ideas sound stronger using simple words.",
      tamilOutcome:
        "நீங்கள் எளிய வார்த்தைகளால் உங்கள் கருத்துகளை வலிமையாக சொல்ல முடியும்.",
      patterns: ["It is very...", "It is so...", "I am very..."],
      video: {
        provider: "vimeo",
        id: "1193159110",
        ratio: "9:16",
      },
    },
    37: {
      title: "Make Professional Small Talk",
      outcome: "You can ask and answer simple social questions at work.",
      tamilOutcome:
        "நீங்கள் வேலை இடத்தில் எளிய சமூக கேள்விகள் கேட்டு பதில் சொல்ல முடியும்.",
      patterns: ["How are you?", "How is work?", "I am doing well."],
      video: {
        provider: "vimeo",
        id: "1193159151",
        ratio: "9:16",
      },
    },
    38: {
      title: "Meet a Colleague or Business Contact",
      outcome: "You can greet and introduce yourself to a work contact.",
      tamilOutcome:
        "நீங்கள் ஒரு வேலை தொடர்பை வரவேற்று உங்களை அறிமுகப்படுத்த முடியும்.",
      patterns: ["Nice to meet you.", "This is...", "I work with..."],
      video: {
        provider: "vimeo",
        id: "1193159998",
        ratio: "9:16",
      },
    },
    39: {
      title: "Describe an Ideal Team Member",
      outcome: "You can describe a good team member or candidate.",
      tamilOutcome:
        "நீங்கள் ஒரு நல்ல குழு உறுப்பினர் அல்லது வேட்பாளர் பற்றி விவரிக்க முடியும்.",
      patterns: ["He is very...", "She is good at...", "We need someone..."],
      video: {
        provider: "vimeo",
        id: "1193159808",
        ratio: "9:16",
      },
    },
    40: {
      title: "Describe People and Situations Clearly",
      outcome: "You can describe people, feelings, and situations clearly.",
      tamilOutcome:
        "நீங்கள் மனிதர்கள், உணர்வுகள், சூழ்நிலைகளை தெளிவாக விவரிக்க முடியும்.",
      patterns: ["He is...", "I feel...", "It is very..."],
      video: {
        provider: "vimeo",
        id: "1193160095",
        ratio: "9:16",
      },
    },
    41: {
      title: "Talk About What You Can Do",
      outcome: "You can speak about your basic abilities.",
      tamilOutcome: "நீங்கள் செய்யக்கூடிய விஷயங்களை எளிதாக சொல்ல முடியும்.",
      patterns: ["I can...", "I can do...", "I can handle..."],
      video: {
        provider: "vimeo",
        id: "1193161740",
        ratio: "9:16",
      },
    },
    42: {
      title: "Say What You Cannot Do Yet",
      outcome: "You can say what you cannot do now.",
      tamilOutcome: "நீங்கள் இப்போது செய்ய முடியாததை சொல்ல முடியும்.",
      patterns: ["I can’t...", "I can’t do...", "I can’t handle..."],
      video: {
        provider: "vimeo",
        id: "1193161794",
        ratio: "9:16",
      },
    },
    43: {
      title: "Ask for Help Politely at Work",
      outcome: "You can ask someone for help in a polite way.",
      tamilOutcome: "நீங்கள் வேலை இடத்தில் மரியாதையாக உதவி கேட்க முடியும்.",
      patterns: [
        "Can you help me?",
        "Can you check...?",
        "Can you explain...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193161841",
        ratio: "9:16",
      },
    },
    44: {
      title: "Ask for Permission Professionally",
      outcome: "You can ask for permission in simple professional English.",
      tamilOutcome:
        "நீங்கள் எளிய தொழில்முறை ஆங்கிலத்தில் அனுமதி கேட்க முடியும்.",
      patterns: ["Can I...?", "Can I use...?", "Can I take...?"],
      video: {
        provider: "vimeo",
        id: "1193161945",
        ratio: "9:16",
      },
    },
    45: {
      title: "Talk About Languages and Skills",
      outcome: "You can speak about the languages and skills you know.",
      tamilOutcome:
        "நீங்கள் அறிந்த மொழிகள் மற்றும் திறன்கள் பற்றி பேச முடியும்.",
      patterns: ["I can speak...", "I can use...", "I know how to..."],
      video: {
        provider: "vimeo",
        id: "1193161974",
        ratio: "9:16",
      },
    },
    46: {
      title: "Describe How Well You Do Something",
      outcome: "You can say how well or badly you do something.",
      tamilOutcome:
        "நீங்கள் ஒரு செயலை எவ்வளவு நன்றாக செய்கிறீர்கள் என்று சொல்ல முடியும்.",
      patterns: ["I do it well.", "I speak well.", "I don’t do it well."],
      video: {
        provider: "vimeo",
        id: "1193183510",
        ratio: "9:16",
      },
    },
    47: {
      title: "Talk About General Facts and Abilities",
      outcome: "You can speak about simple facts and natural abilities.",
      tamilOutcome:
        "நீங்கள் எளிய உண்மைகள் மற்றும் இயல்பான திறன்கள் பற்றி பேச முடியும்.",
      patterns: ["Birds can...", "Fish can...", "People can..."],
      video: {
        provider: "vimeo",
        id: "1193183566",
        ratio: "9:16",
      },
    },
    48: {
      title: "Present Your Skills in an Interview",
      outcome: "You can talk about your skills in a job interview.",
      tamilOutcome:
        "நீங்கள் வேலை நேர்காணலில் உங்கள் திறன்கள் பற்றி பேச முடியும்.",
      patterns: ["I can...", "I am good at...", "I have experience in..."],
      video: {
        provider: "vimeo",
        id: "1193183647",
        ratio: "9:16",
      },
    },
    49: {
      title: "Build Skill Confidence",
      outcome: "You can speak confidently about what you can and cannot do.",
      tamilOutcome:
        "நீங்கள் செய்யக்கூடியதும் செய்ய முடியாததும் பற்றி நம்பிக்கையுடன் பேச முடியும்.",
      patterns: ["I can...", "I can’t...", "I want to learn..."],
      video: {
        provider: "vimeo",
        id: "1193183721",
        ratio: "9:16",
      },
    },
    50: {
      title: "Speak About Skills and Permission",
      outcome:
        "You can talk about skills, ask for help, and ask for permission.",
      tamilOutcome:
        "நீங்கள் திறன்கள் பற்றி பேசவும், உதவி மற்றும் அனுமதி கேட்கவும் முடியும்.",
      patterns: ["I can...", "Can you...?", "Can I...?"],
      video: {
        provider: "vimeo",
        id: "1193183770",
        ratio: "9:16",
      },
    },
    51: {
      title: "Say What You Are Doing Now",
      outcome: "You can talk about actions happening right now.",
      tamilOutcome: "நீங்கள் இப்போது நடக்கும் செயல்கள் பற்றி சொல்ல முடியும்.",
      patterns: ["I am working...", "I am checking...", "I am waiting..."],
      video: {
        provider: "vimeo",
        id: "1193183814",
        ratio: "9:16",
      },
    },
    52: {
      title: "Talk About What Others Are Doing",
      outcome: "You can describe what another person is doing now.",
      tamilOutcome:
        "நீங்கள் மற்றொருவர் இப்போது என்ன செய்கிறார் என்று சொல்ல முடியும்.",
      patterns: [
        "He is working...",
        "She is talking...",
        "They are checking...",
      ],
      video: {
        provider: "vimeo",
        id: "1193183982",
        ratio: "9:16",
      },
    },
    53: {
      title: "Ask About Current Activities",
      outcome: "You can ask what people are doing now.",
      tamilOutcome:
        "நீங்கள் மக்கள் இப்போது என்ன செய்கிறார்கள் என்று கேட்க முடியும்.",
      patterns: ["Are they working?", "Is he coming?", "Is she speaking?"],
      video: {
        provider: "vimeo",
        id: "1193184074",
        ratio: "9:16",
      },
    },
    54: {
      title: "Say What Is Not Happening Now",
      outcome: "You can say what you or others are not doing now.",
      tamilOutcome:
        "நீங்கள் அல்லது மற்றவர்கள் இப்போது செய்யாததை சொல்ல முடியும்.",
      patterns: ["I am not...", "We aren’t...", "They aren’t..."],
      video: {
        provider: "vimeo",
        id: "1193184111",
        ratio: "9:16",
      },
    },
    55: {
      title: "Talk About Weather and Travel Conditions",
      outcome: "You can describe the weather and simple travel conditions.",
      tamilOutcome:
        "நீங்கள் வானிலை மற்றும் பயண நிலையை எளிதாக விவரிக்க முடியும்.",
      patterns: ["It is raining.", "It is sunny.", "It is very cold."],
      video: {
        provider: "vimeo",
        id: "1193184172",
        ratio: "9:16",
      },
    },
    56: {
      title: "Describe What People Are Wearing",
      outcome: "You can describe clothes in a professional way.",
      tamilOutcome:
        "நீங்கள் உடைகளை மரியாதையாகவும் தொழில்முறையாகவும் விவரிக்க முடியும்.",
      patterns: ["I am wearing...", "He is wearing...", "She is wearing..."],
      video: {
        provider: "vimeo",
        id: "1193164475",
        ratio: "9:16",
      },
    },
    57: {
      title: "Avoid Action and State Verb Mistakes",
      outcome: "You can use action and state verbs more correctly.",
      tamilOutcome:
        "நீங்கள் செயல் வினைச்சொற்கள் மற்றும் நிலை வினைச்சொற்களை சரியாக பயன்படுத்த முடியும்.",
      patterns: ["I like...", "I am eating...", "I know..."],
      video: {
        provider: "vimeo",
        id: "1193164623",
        ratio: "9:16",
      },
    },
    58: {
      title: "Explain What Is Happening on a Call",
      outcome: "You can explain a current situation during a phone call.",
      tamilOutcome:
        "நீங்கள் தொலைபேசி அழைப்பில் இப்போது என்ன நடக்கிறது என்று விளக்க முடியும்.",
      patterns: [
        "I am calling from...",
        "I am checking...",
        "It is happening now.",
      ],
      video: {
        provider: "vimeo",
        id: "1193164691",
        ratio: "9:16",
      },
    },
    59: {
      title: "Describe Many Actions Live",
      outcome: "You can describe many actions happening around you.",
      tamilOutcome:
        "உங்களைச் சுற்றி நடக்கும் பல செயல்களை நீங்கள் விவரிக்க முடியும்.",
      patterns: ["People are...", "Someone is...", "They are..."],
      video: {
        provider: "vimeo",
        id: "1193165153",
        ratio: "9:16",
      },
    },
    60: {
      title: "Give Real-Time Updates Clearly",
      outcome: "You can give clear updates about what is happening now.",
      tamilOutcome:
        "இப்போது என்ன நடக்கிறது என்பதை நீங்கள் தெளிவாக அப்டேட் கொடுக்க முடியும்.",
      patterns: [
        "I am working on...",
        "We are checking...",
        "They are waiting...",
      ],
      video: {
        provider: "vimeo",
        id: "1193165234",
        ratio: "9:16",
      },
    },
    61: {
      title: "Talk About Basic Needs",
      outcome: "You can talk about some, any, and simple needs.",
      tamilOutcome: "நீங்கள் சில, ஏதாவது, அடிப்படை தேவைகள் பற்றி பேச முடியும்.",
      patterns: [
        "I need some...",
        "Do you have any...?",
        "I don’t have any...",
      ],
      video: {
        provider: "vimeo",
        id: "1193165255",
        ratio: "9:16",
      },
    },
    62: {
      title: "Say What Is Available or Missing",
      outcome: "You can say what is there and what is not there.",
      tamilOutcome: "எது இருக்கிறது, எது இல்லை என்று நீங்கள் சொல்ல முடியும்.",
      patterns: ["There is...", "There are...", "There isn’t any..."],
      video: {
        provider: "vimeo",
        id: "1193165424",
        ratio: "9:16",
      },
    },
    63: {
      title: "Ask About Quantity Clearly",
      outcome: "You can ask about amount and number clearly.",
      tamilOutcome:
        "நீங்கள் அளவு மற்றும் எண்ணிக்கை பற்றி தெளிவாக கேட்க முடியும்.",
      patterns: ["How much...?", "How many...?", "Do we have enough...?"],
      video: {
        provider: "vimeo",
        id: "1193165507",
        ratio: "9:16",
      },
    },
    64: {
      title: "Talk About Large Amounts",
      outcome: "You can talk about many things or large amounts naturally.",
      tamilOutcome:
        "நீங்கள் அதிகமான பொருட்கள் அல்லது அளவு பற்றி இயல்பாக பேச முடியும்.",
      patterns: [
        "There are a lot of...",
        "We have a lot of...",
        "I need a lot of...",
      ],
      video: {
        provider: "vimeo",
        id: "1193165554",
        ratio: "9:16",
      },
    },
    65: {
      title: "Talk About Food and Daily Needs",
      outcome: "You can ask for fruits, vegetables, and daily items.",
      tamilOutcome:
        "நீங்கள் பழங���கள், காய்���றிகள், தின���ரs�� பொ���ுட்கள் பற்றி கேட்க முடிt��ும்.",
      patterns: ["I need an...", "I want some...", "Do you have...?"],
      video: {
        provider: "vimeo",
        id: "1193165566",
        ratio: "9:16",
      },
    },
    66: {
      title: "Use Quantity Phrases",
      outcome: "You can use quantity phrases in daily situations.",
      tamilOutcome:
        "நீங்கள் தினசரி சூழ்நிலைகளில் அளவு சொற்களை பயன்படுத்த மு���ி���ும்.",
      patterns: ["A cup of...", "A bottle of...", "A packet of..."],
      video: {
        provider: "vimeo",
        id: "1193188762",
        ratio: "9:16",
      },
    },
    67: {
      title: "Ask About Prices and Costs",
      outcome: "You can ask and talk about prices clearly.",
      tamilOutcome: "நீங்கள் விலை மற்றும் செலவு பற்றி தெளிவாக கேட்க முடியும்.",
      patterns: ["How much is it?", "How much does it cost?", "It costs..."],
      video: {
        provider: "vimeo",
        id: "1193188858",
        ratio: "9:16",
      },
    },
    68: {
      title: "Shop and Confirm Items",
      outcome: "You can ask, buy, and confirm items at a grocery store.",
      tamilOutcome:
        "நீங்கள் மளிகைக் கடையில் பொருட்களை கேட்டு, வாங்கி, உறுதி செய்ய முடியும்.",
      patterns: ["Do you have...?", "I need some...", "How much is...?"],
      video: {
        provider: "vimeo",
        id: "1193188889",
        ratio: "9:16",
      },
    },
    69: {
      title: "Plan With Quantity and Needs",
      outcome: "You can talk about ingredients, needs, and quantities.",
      tamilOutcome: "நீங்கள் பொருட்கள், தேவைகள், அளவுகள் பற்றி பேச முடியும்.",
      patterns: ["We need...", "Add some...", "How many...?"],
      video: {
        provider: "vimeo",
        id: "1193188997",
        ratio: "9:16",
      },
    },
    70: {
      title: "Talk About Needs, Quantity, and Price",
      outcome: "You can discuss needs, amounts, and prices in English.",
      tamilOutcome:
        "நீங்கள் தேவைகள், அளவுகள், விலைகள் பற்றி ஆங்கிலத்தில் பேச முடியும்.",
      patterns: ["I need some...", "How much is...?", "There are a lot of..."],
      video: {
        provider: "vimeo",
        id: "1193189069",
        ratio: "9:16",
      },
    },
    71: {
      title: "Use Numbers in Daily Work Conversations",
      outcome: "You can use numbers clearly in daily work conversations.",
      tamilOutcome:
        "நீங்கள் தினசரி வேலை உரையாடல்களில் எண்களை தெளிவாக பயன்படுத்த முடியும்.",
      patterns: ["I need...", "There are...", "My number is..."],
      video: {
        provider: "vimeo",
        id: "1193189080",
        ratio: "9:16",
      },
    },
    72: {
      title: "Tell and Ask the Time Clearly",
      outcome: "You can ask and say the time confidently.",
      tamilOutcome: "நீங்கள் நேரத்தை நம்பிக்கையுடன் கேட்டு சொல்ல முடியும்.",
      patterns: ["What time is it?", "It is...", "At..."],
      video: {
        provider: "vimeo",
        id: "1193189285",
        ratio: "9:16",
      },
    },
    73: {
      title: "Talk About Days, Months, and Plans",
      outcome: "You can speak about days, months, and simple plans.",
      tamilOutcome:
        "நீங்கள் நாட்கள், மாதங்கள், எளிய திட்டங்கள் பற்றி பேச முடியும்.",
      patterns: ["On Monday...", "In July...", "Next week..."],
      video: {
        provider: "vimeo",
        id: "1193189350",
        ratio: "9:16",
      },
    },
    74: {
      title: "Use Dates, Rankings, and Order",
      outcome: "You can use order words like first, second, and third.",
      tamilOutcome:
        "நீங்கள் முதல், இரண்டாவது, மூன்றாவது போன்ற வரிசை சொற்களை பயன்படுத்த முடியும்.",
      patterns: ["First...", "Second...", "The first meeting..."],
      video: {
        provider: "vimeo",
        id: "1193189453",
        ratio: "9:16",
      },
    },
    75: {
      title: "Ask and Confirm Schedules",
      outcome: "You can ask when something is happening and confirm the time.",
      tamilOutcome:
        "நீங்கள் ஒரு விஷயம் எப்போது நடக்கிறது என்று கேட்டு நேரத்தை உறுதி செய்ய முடியும்.",
      patterns: ["When is...?", "When do we...?", "Is it at...?"],
      video: {
        provider: "vimeo",
        id: "1193189497",
        ratio: "9:16",
      },
    },
    76: {
      title: "Talk About Being Early, Late, and On Time",
      outcome: "You can talk about time management in simple English.",
      tamilOutcome: "நீங்கள் நேர மேலாண்மை பற்றி ஆங்கிலத்தில் பேச முடியும்.",
      patterns: ["I am early.", "I am late.", "I am on time."],
      video: {
        provider: "vimeo",
        id: "1193219391",
        ratio: "9:16",
      },
    },
    77: {
      title: "Explain Steps in the Right Order",
      outcome: "You can explain what happens before and after something.",
      tamilOutcome:
        "நீங்கள் ஒரு விஷயத்திற்கு முன் மற்றும் பின் என்ன நடக்கிறது என்று விளக்க முடியும்.",
      patterns: ["Before...", "After...", "First, then..."],
      video: {
        provider: "vimeo",
        id: "1193219509",
        ratio: "9:16",
      },
    },
    78: {
      title: "Book and Confirm an Appointment",
      outcome: "You can book and confirm a doctor’s appointment.",
      tamilOutcome:
        "நீங்கள் மருத்துவர் அப்பாயிண்ட்மெண்ட் பதிவு செய்து உறுதி செய்ய முடியும்.",
      patterns: [
        "I need an appointment.",
        "Is the doctor available?",
        "Can I come at...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193219680",
        ratio: "9:16",
      },
    },
    79: {
      title: "Plan Your Schedule Clearly",
      outcome: "You can speak about dates, times, and plans together.",
      tamilOutcome:
        "நீங்கள் தேதிகள், நேரங்கள், திட்டங்கள் பற்றி சேர்த்து பேச முடியும்.",
      patterns: ["On Monday at...", "Before the meeting...", "After work..."],
      video: {
        provider: "vimeo",
        id: "1193219693",
        ratio: "9:16",
      },
    },
    80: {
      title: "Manage Time and Appointments in English",
      outcome: "You can manage schedules, time, and appointments in English.",
      tamilOutcome:
        "நீங்கள் நேரம், அட்டவணை, அப்பாயிண்ட்மெண்  �்களை ஆங்கிலத்தில் நிர்வகிக்க முடியும்.",
      patterns: ["What time...?", "When is...?", "Can I come at...?"],
      video: {
        provider: "vimeo",
        id: "1193219812",
        ratio: "9:16",
      },
    },
    81: {
      title: "Talk About the Past",
      outcome: "You can talk about past identity and situations.",
      tamilOutcome:
        "நீங்கள் கடந்த கால அடையாளம் மற���றும் சூழ்நிலைகள் பற்றி பேச முடியும்.",
      patterns: ["I was...", "You were...", "We were..."],
      video: {
        provider: "vimeo",
        id: "1193219828",
        ratio: "9:16",
      },
    },
    82: {
      title: "Say What Was Not True in the Past",
      outcome: "You can say what was not true before.",
      tamilOutcome: "முன்பு உண்மை இல்லாததை நீங்கள் சொல்ல முடியும்.",
      patterns: ["I wasn’t...", "They weren’t...", "It wasn’t..."],
      video: {
        provider: "vimeo",
        id: "1193219977",
        ratio: "9:16",
      },
    },
    83: {
      title: "Ask About Past Situations",
      outcome: "You can ask simple questions about the past.",
      tamilOutcome: "நீங்கள் கடந்த காலம் பற்றி எளிய கேள்விகள் கேட்க முடியும்.",
      patterns: ["Were you there?", "Was he there?", "Were they ready?"],
      video: {
        provider: "vimeo",
        id: "1193220102",
        ratio: "9:16",
      },
    },
    84: {
      title: "Use Past Time Words Clearly",
      outcome: "You can use past time words while speaking.",
      tamilOutcome:
        "நீங்கள் பேசும்போது கடந்த கால நேர வார்த்தைகளை பயன்படுத்த முடியும்.",
      patterns: ["Yesterday...", "Last week...", "Last month..."],
      video: {
        provider: "vimeo",
        id: "1193220161",
        ratio: "9:16",
      },
    },
    85: {
      title: "Talk About Your Background",
      outcome: "You can speak about where you were born and raised.",
      tamilOutcome:
        "நீங்கள் பிறந்த இடம் மற்றும் வளர்ந்த இடம் பற்றி பேச முடியும்.",
      patterns: ["I was born in...", "I was raised in...", "I grew up in..."],
      video: {
        provider: "vimeo",
        id: "1193220225",
        ratio: "9:16",
      },
    },
    86: {
      title: "Share Opinions About Past Events",
      outcome: "You can say how a past event was.",
      tamilOutcome:
        "கடந்த நிகழ்வு எப்படி இருந்தது என்று நீங்கள் சொல்ல முடியும்.",
      patterns: ["It was good.", "It was difficult.", "How was it?"],
      video: {
        provider: "vimeo",
        id: "1193223407",
        ratio: "9:16",
      },
    },
    87: {
      title: "Say What Was Available",
      outcome: "You can talk about what was there before.",
      tamilOutcome: "முன்பு என்ன இருந்தது என்று நீங்கள் சொல்ல முடியும்.",
      patterns: ["There was...", "There were...", "There wasn’t..."],
      video: {
        provider: "vimeo",
        id: "1193223483",
        ratio: "9:16",
      },
    },
    88: {
      title: "Talk About a Vacation",
      outcome: "You can describe a past trip in simple English.",
      tamilOutcome: "நீங்கள் கடந்த பயணம் பற்றி எளிய ஆங்கிலத்தில் பேச முடியும்.",
      patterns: ["I was in...", "It was...", "There were..."],
      video: {
        provider: "vimeo",
        id: "1193223678",
        ratio: "9:16",
      },
    },
    89: {
      title: "Talk About Past Facts",
      outcome: "You can speak about simple facts from the past.",
      tamilOutcome: "நீங்கள் கடந்த கால உண்மைகள் பற்றி எளிதாக பேச முடியும்.",
      patterns: ["It was...", "They were...", "There was..."],
      video: {
        provider: "vimeo",
        id: "1193252660",
        ratio: "9:16",
      },
    },
    90: {
      title: "Speak About Past Experiences",
      outcome: "You can talk about past places, events, and experiences.",
      tamilOutcome:
        "நீங்கள் கடந்த இடங்கள், நிகழ்வுகள், அனுபவங்கள் பற்றி பேச முடியும்.",
      patterns: ["I was...", "It was...", "There were..."],
      video: {
        provider: "vimeo",
        id: "1193223805",
        ratio: "9:16",
      },
    },
    91: {
      title: "Talk About Completed Actions",
      outcome: "You can talk about actions you completed in the past.",
      tamilOutcome:
        "நீங்கள் கடந்த காலத்தில் முடித்த செயல்கள் பற்றி பேச முடியும்.",
      patterns: ["I worked...", "I played...", "I finished..."],
      video: {
        provider: "vimeo",
        id: "1193252795",
        ratio: "9:16",
      },
    },
    92: {
      title: "Use Common Past Action Verbs",
      outcome: "You can use common past verbs in daily speaking.",
      tamilOutcome:
        "நீங்கள் தினசரி பேச்சில் பொதுவான கடந்த கால வினைச்சொற்களை பயன்படுத்த முடியும்.",
      patterns: ["I went...", "I ate...", "I saw..."],
      video: {
        provider: "vimeo",
        id: "1193252889",
        ratio: "9:16",
      },
    },
    93: {
      title: "Say What Did Not Happen",
      outcome: "You can say what you did not do in the past.",
      tamilOutcome: "நீங்கள் கடந்த காலத்தில் செய்யாததை சொல்ல முடியும்.",
      patterns: ["I didn’t...", "He didn’t...", "They didn’t..."],
      video: {
        provider: "vimeo",
        id: "1193252957",
        ratio: "9:16",
      },
    },
    94: {
      title: "Ask About Completed Tasks and Events",
      outcome: "You can ask simple questions about past actions.",
      tamilOutcome:
        "நீங்கள் கடந்த செயல்கள் பற்றி எளிய கேள்விகள் கேட்க முடியும்.",
      patterns: ["Did you...?", "Did he...?", "Did they...?"],
      video: {
        provider: "vimeo",
        id: "1193253021",
        ratio: "9:16",
      },
    },
    95: {
      title: "Give Short Past Answers",
      outcome: "You can answer past questions clearly and quickly.",
      tamilOutcome:
        "நீங்கள் கடந்த கால கேள்விகளுக்கு தெளிவாகவும் விரைவாகவும் பதில் சொல்ல முடியும்.",
      patterns: ["Yes, I did.", "No, I didn’t.", "Yes, we did."],
      video: {
        provider: "vimeo",
        id: "1193253144",
        ratio: "9:16",
      },
    },
    96: {
      title: "Explain Events in Order",
      outcome: "You can explain past events in the right order.",
      tamilOutcome:
        "நீங்கள் கடந்த நிகழ்வுகளை சரியான வரிசையில் விளக்க முடியும்.",
      patterns: ["First...", "Then...", "Finally..."],
      video: {
        provider: "vimeo",
        id: "1193253232",
        ratio: "9:16",
      },
    },
    97: {
      title: "Say When Something Happened",
      outcome: "You can say when something happened in the past.",
      tamilOutcome: "ஒரு விஷயம் எப்போது நடந்தது என்று நீங்கள் சொல்ல முடியும்.",
      patterns: ["Three days ago...", "A week ago...", "Long ago..."],
      video: {
        provider: "vimeo",
        id: "1193253318",
        ratio: "9:16",
      },
    },
    98: {
      title: "Explain What Happened",
      outcome: "You can explain an incident or problem clearly.",
      tamilOutcome:
        "நீங்கள் ஒரு சம்பவம் அல்லது பிரச்சனையை தெளிவாக விளக்க முடியும்.",
      patterns: ["What happened?", "I saw...", "Then I..."],
      video: {
        provider: "vimeo",
        id: "1193253471",
        ratio: "9:16",
      },
    },
    99: {
      title: "Tell a Workday Story",
      outcome: "You can tell a short story about your day.",
      tamilOutcome:
        "நீங்கள் உங்கள் நாள் பற்றி ஒரு சிறிய கதையாக சொல்ல முடியும்.",
      patterns: ["Last night...", "First I...", "Then I..."],
      video: {
        provider: "vimeo",
        id: "1193253591",
        ratio: "9:16",
      },
    },
    100: {
      title: "Report Past Actions Clearly",
      outcome: "You can report past actions and events in English.",
      tamilOutcome:
        "நீங்கள் கடந்த செயல்கள் மற்றும் நிகழ்வுகளை ஆங்கிலத்தில் தெளிவாக சொல்ல முடியும்.",
      patterns: ["I worked...", "I didn’t...", "Did you...?"],
      video: {
        provider: "vimeo",
        id: "1193253650",
        ratio: "9:16",
      },
    },
    101: {
      title: "Talk About Your Future Plans",
      outcome: "You can speak about what you are going to do.",
      tamilOutcome: "நீங்கள் என்ன செய்யப் போகிறீர்கள் என்று பேச முடியும்.",
      patterns: ["I am going to...", "I’m going to...", "We are going to..."],
      video: {
        provider: "vimeo",
        id: "1193259521",
        ratio: "9:16",
      },
    },
    102: {
      title: "Ask About Someone’s Plans",
      outcome: "You can ask what someone is going to do.",
      tamilOutcome:
        "நீங்கள் ஒருவர் என்ன செய்யப் போகிறார் என்று கேட்க முடியும்.",
      patterns: [
        "Are you going to...?",
        "Is he going to...?",
        "Are they going to...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193259991",
        ratio: "9:16",
      },
    },
    103: {
      title: "Make Simple Predictions",
      outcome: "You can say what you think will happen soon.",
      tamilOutcome: "விரைவில் என்ன நடக்கும் என்று நீங்கள் சொல்ல முடியும்.",
      patterns: [
        "It is going to...",
        "It’s going to rain.",
        "I think it will...",
      ],
      video: {
        provider: "vimeo",
        id: "1193260100",
        ratio: "9:16",
      },
    },
    104: {
      title: "Use Future Time Words Clearly",
      outcome: "You can talk about future actions using time words.",
      tamilOutcome:
        "நீங்கள் நேர வார்த்தைகளுடன் எதிர்கால செயல்களை பேச முடியும்.",
      patterns: ["Tonight...", "Tomorrow...", "Next week..."],
      video: {
        provider: "vimeo",
        id: "1193260173",
        ratio: "9:16",
      },
    },
    105: {
      title: "Talk About Travel Plans",
      outcome: "You can speak about where you are going to travel.",
      tamilOutcome:
        "நீங்கள் எங்கு பயணம் செய்யப் போகிறீர்கள் என்று பேச முடியும்.",
      patterns: [
        "I’m going to visit...",
        "I’m going to travel to...",
        "I’m going with...",
      ],
      video: {
        provider: "vimeo",
        id: "1193260248",
        ratio: "9:16",
      },
    },
    106: {
      title: "Use Informal Future English",
      outcome: "You can understand and use simple informal future expressions.",
      tamilOutcome:
        "நீங்கள் எளிய அன்றாட எதிர்கால பேச்சை புரிந்து பயன்படுத்த முடியும்.",
      patterns: ["I’m gonna...", "Are you gonna...?", "We’re gonna..."],
      video: {
        provider: "vimeo",
        id: "1193260379",
        ratio: "9:16",
      },
    },
    107: {
      title: "Talk About Wants, Needs, and Priorities",
      outcome: "You can say what you want, need, and must do first.",
      tamilOutcome: "நீங்கள் விருப்பம், தேவை, முன்னுரிமை பற்றி சொல்ல முடியும்.",
      patterns: ["I want to...", "I need to...", "I have to..."],
      video: {
        provider: "vimeo",
        id: "1193260394",
        ratio: "9:16",
      },
    },
    108: {
      title: "Plan an Event",
      outcome: "You can discuss simple plans for an event.",
      tamilOutcome: "நீங்கள் ஒரு நிகழ்ச்சிக்கான எளிய திட்டங்களை பேச முடியும்.",
      patterns: ["We are going to...", "We need to...", "Let’s plan..."],
      video: {
        provider: "vimeo",
        id: "1193260498",
        ratio: "9:16",
      },
    },
    109: {
      title: "Talk About Career Goals",
      outcome: "You can speak about your long-term goals.",
      tamilOutcome: "நீங்கள் உங்கள் நீண்டகால இலக்குகள் பற்றி பேச முடியும்.",
      patterns: [
        "In five years...",
        "I’m going to become...",
        "I want to improve...",
      ],
      video: {
        provider: "vimeo",
        id: "1193260602",
        ratio: "9:16",
      },
    },
    110: {
      title: "Discuss Plans and Next Steps",
      outcome: "You can talk about future plans, goals, and next steps.",
      tamilOutcome:
        "நீங்கள் எதிர்கால திட்டங்கள், இலக்குகள், அடுத்த படிகள் பற்றி பேச முடியும்.",
      patterns: ["I’m going to...", "I need to...", "Next, I will..."],
      video: {
        provider: "vimeo",
        id: "1193260656",
        ratio: "9:16",
      },
    },
    111: {
      title: "Compare Two Options Clearly",
      outcome: "You can compare two people, places, or things clearly.",
      tamilOutcome:
        "நீங்கள் இரண்டு மனிதர்கள், இடங்கள் அல்லது பொருட்களை தெளிவாக ஒப்பிட முடியும்.",
      patterns: ["Bigger than...", "Cheaper than...", "Better than..."],
      video: {
        provider: "vimeo",
        id: "1193264482",
        ratio: "9:16",
      },
    },
    112: {
      title: "Talk About the Best Option",
      outcome: "You can talk about the best, biggest, or most useful option.",
      tamilOutcome:
        "நீங்கள் சிறந்த, பெரிய, பயனுள்ள விருப்பம் பற்றி பேச முடியும்.",
      patterns: ["The biggest...", "The best...", "The most useful..."],
      video: {
        provider: "vimeo",
        id: "1193264570",
        ratio: "9:16",
      },
    },
    113: {
      title: "Compare Important Qualities",
      outcome: "You can compare features and qualities using more and most.",
      tamilOutcome:
        "நீங்கள் அம்சங்கள் மற்றும் தரங்களை more, most கொண்டு ஒப்பிட முடியும்.",
      patterns: [
        "More important than...",
        "More useful than...",
        "The most comfortable...",
      ],
      video: {
        provider: "vimeo",
        id: "1193264704",
        ratio: "9:16",
      },
    },
    114: {
      title: "Use Better and Best Correctly",
      outcome: "You can use good, better, and best in daily speaking.",
      tamilOutcome:
        "நீங்கள் good, better, best-ஐ ���ினசரி பேச்சில் சரியாக பயன்படுத்த முடியும்.",
      patterns: ["It is good.", "This is better.", "That is the best."],
      video: {
        provider: "vimeo",
        id: "1193264804",
        ratio: "9:16",
      },
    },
    115: {
      title: "Say Two Things Are Similar",
      outcome: "You can say two things are equal or similar.",
      tamilOutcome:
        "நீங்கள் இரண்டு விஷயங்கள் சமம் அல்லது ஒரே மாதிரி என்று சொல்ல முடியும்.",
      patterns: ["As good as...", "As big as...", "As useful as..."],
      video: {
        provider: "vimeo",
        id: "1193264947",
        ratio: "9:16",
      },
    },
    116: {
      title: "Give and Follow Simple Directions",
      outcome: "You can give and understand simple directions.",
      tamilOutcome:
        "நீங்கள் எளிய வழிமுறைகளை சொல்லவும் புரிந்துகொள்ளவும் முடியும்.",
      patterns: ["Turn left.", "Go straight.", "It is near..."],
      video: {
        provider: "vimeo",
        id: "1193265051",
        ratio: "9:16",
      },
    },
    117: {
      title: "Make Simple Suggestions Politely",
      outcome: "You can suggest ideas in a polite way.",
      tamilOutcome: "நீங்கள் யோசனைகளை மரியாதையாக பரிந்துரைக்க முடியும்.",
      patterns: ["Why don’t we...?", "Let’s...", "We can..."],
      video: {
        provider: "vimeo",
        id: "1193265183",
        ratio: "9:16",
      },
    },
    118: {
      title: "Compare Rooms at a Hotel",
      outcome: "You can compare rooms and ask for better options.",
      tamilOutcome:
        "நீங்கள் ஹோட்டல் அறைகளை ஒப்பிட்டு நல்ல விருப்பம் கேட்க முடியும்.",
      patterns: [
        "This room is...",
        "Do you have a better...?",
        "Which room is...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193265318",
        ratio: "9:16",
      },
    },
    119: {
      title: "Complete a Workplace English Challenge",
      outcome: "You can use mixed tenses and patterns in workplace situations.",
      tamilOutcome:
        "நீங்கள் வேலை சூழ்நிலைகளில் பல காலங்கள் மற்றும் patterns பயன்படுத்த முடியும்.",
      patterns: ["I worked...", "I am working...", "I’m going to..."],
      video: {
        provider: "vimeo",
        id: "1193265462",
        ratio: "9:16",
      },
    },
    120: {
      title: "Complete Final English Mastery",
      outcome:
        "You can introduce yourself, speak about work, and handle daily situations.",
      tamilOutcome:
        "நீங்கள் உங்களை அறிமுகப்படுத்தி, வேலை மற்றும் தினசரி சூழ்நிலைகள் பற்றி பேச முடியுமfy�.",
      patterns: ["I am...", "I can...", "I need to..."],
      video: {
        provider: "vimeo",
        id: "1193265498",
        ratio: "9:16",
      },
    },
  },

  intermediate: {
    1: {
      title: "Upgrade Your Self-Introduction",
      outcome:
        "You can give a stronger and more complete personal introduction.",
      tamilOutcome: "வேற லெவல் Self Intro குடுங்க .",
      patterns: [
        "I’m currently...",
        "I have experience in...",
        "My goal is...",
      ],
      video: {
        provider: "vimeo",
        id: "1194960524",
        ratio: "9:16",
      },
    },
    2: {
      title: "Describe Your Job Role Clearly",
      outcome: "You can explain your work and responsibilities clearly.",
      tamilOutcome:
        "நீங்கள் உங்கள் வேலை மற்றும் பொறுப்புகளை தெளிவாக விளக்க முடியும்.",
      patterns: [
        "I work as...",
        "I’m responsible for...",
        "My role involves...",
      ],
      video: {
        provider: "vimeo",
        id: "1194960549",
        ratio: "9:16",
      },
    },
    3: {
      title: "Create Sentences With 4 Powerful Patterns",
      outcome:
        "You can speak about your routine, effort, wants, and hopes instantly.",
      tamilOutcome:
        "நீங்கள் உங்கள் வழக்கம், முயற்சி, விருப்பம், நம்பிக்கை பற்றி உடனே பேச முடியும்.",
      patterns: ["I usually...", "I’m trying to...", "I hope to..."],
      video: {
        provider: "vimeo",
        id: "1194960860",
        ratio: "9:16",
      },
    },
    4: {
      title: "Talk About Your Strengths",
      outcome: "You can speak about your skills and strengths confidently.",
      tamilOutcome:
        "நீங்கள் உங்கள் திறன்கள் மற்றும் பலங்களை நம்பிக்கையுடன் பேச முடியும்.",
      patterns: ["I’m good at...", "I know how to...", "I can handle..."],
      video: {
        provider: "vimeo",
        id: "1194960875",
        ratio: "9:16",
      },
    },
    5: {
      title: "Talk About Your Experience",
      outcome: "You can speak about your work experience naturally.",
      tamilOutcome: "நீங்கள் உங்கள் வேலை அனுபவத்தை இயல்பாக பேச முடியும்.",
      patterns: [
        "I’ve worked in...",
        "I’ve handled...",
        "I’ve been part of...",
      ],
      video: {
        provider: "vimeo",
        id: "1193292488",
        ratio: "9:16",
      },
    },
    6: {
      title: "Explain Your Future Goals",
      outcome: "You can talk about your plans, goals, and dreams.",
      tamilOutcome:
        "நீங்கள் உங்கள் திட்டங்கள், இலக்குகள், கனவுகள் பற்றி பேச முடியும்.",
      patterns: ["I’m planning to...", "I hope to...", "I aim to..."],
      video: {
        provider: "vimeo",
        id: "1193292786",
        ratio: "9:16",
      },
    },
    7: {
      title: "Describe Yourself Professionally",
      outcome:
        "You can describe your personality in a positive professional way.",
      tamilOutcome:
        "நீங்கள் உங்கள் குணங்களை தொழில்முறையாகவும் நேர்மறையாகவும் விவரிக்க முடியும்.",
      patterns: ["I’m reliable.", "I’m proactive.", "I’m detail-oriented."],
      video: {
        provider: "vimeo",
        id: "1193292843",
        ratio: "9:16",
      },
    },
    8: {
      title: "Talk About Strengths Humbly",
      outcome: "You can sound confident without sounding boastful.",
      tamilOutcome: "நீங்கள் பெருமை பேசாமல் நம்பிக்கையுடன் பேச முடியும்.",
      patterns: [
        "One of my strengths is...",
        "I’m quite good at...",
        "I try to...",
      ],
      video: {
        provider: "vimeo",
        id: "1193292908",
        ratio: "9:16",
      },
    },
    9: {
      title: "Introduce Someone Professionally",
      outcome:
        "You can introduce a colleague or contact in a professional way.",
      tamilOutcome:
        "நீங்கள் சக ஊழியர் அல்லது தொடர்பை தொழில்முறையாக ��������ிமுகப்படுத்த முடியும்.",
      patterns: [
        "Let me introduce...",
        "This is my colleague...",
        "He is responsible for...",
      ],
      video: {
        provider: "vimeo",
        id: "1193292953",
        ratio: "9:16",
      },
    },
    10: {
      title: "Give a Polished Professional Introduction",
      outcome: "You can give a clear 90-second professional introduction.",
      tamilOutcome:
        "நீங்கள் தெளிவான 90 விநாடி தொழில்முறை அறிமுகம் கொடுக்க முடியும்.",
      patterns: ["I’m currently...", "I’ve worked in...", "My goal is..."],
      video: {
        provider: "vimeo",
        id: "1193292997",
        ratio: "9:16",
      },
    },
    11: {
      title: "Start the Workday Naturally",
      outcome:
        "You can begin office conversations with natural greetings and small talk.",
      tamilOutcome: "நீங்கள் அலுவலக உரையாடலை இயல்பாக தொடங்க முடியும்.",
      patterns: [
        "Good morning...",
        "How was your...?",
        "Hope you’re doing well.",
      ],
      video: {
        provider: "vimeo",
        id: "1193308392",
        ratio: "9:16",
      },
    },
    12: {
      title: "Ask for Work Updates Professionally",
      outcome: "You can ask for task updates in a clear and professional way.",
      tamilOutcome:
        "நீங்கள் வேலை அப்டேட்டை தெளிவாகவும் தொழில்முறையாகவும் கேட்க முடியும்.",
      patterns: [
        "How is it going?",
        "Any update on...?",
        "Where are we with...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193308488",
        ratio: "9:16",
      },
    },
    13: {
      title: "Give Clear Work Updates",
      outcome: "You can report your work progress confidently.",
      tamilOutcome:
        "நீங்கள் உங்கள் வேலை முன்னேற்றத்தை நம்பிக்கையுடன் சொல்ல முடியும்.",
      patterns: ["I’ve finished...", "I’m working on...", "I’ll complete..."],
      video: {
        provider: "vimeo",
        id: "1193308553",
        ratio: "9:16",
      },
    },
    14: {
      title: "Explain Task Status Clearly",
      outcome: "You can say whether a task is on track, delayed, or pending.",
      tamilOutcome:
        "ஒரு வேலை சரியாக செல்கிறதா, தாமதமா, நிலுவையிலா என்று சொல்ல முடியும்.",
      patterns: ["It’s on track.", "It’s delayed.", "It’s still pending."],
      video: {
        provider: "vimeo",
        id: "1193308713",
        ratio: "9:16",
      },
    },
    15: {
      title: "Make Professional Requests",
      outcome: "You can ask for help or action politely at work.",
      tamilOutcome:
        "நீங்கள் வேலை இடத்தில் உதவி அல்லது செயலை மரியாதையாக கேட்க முடியும்.",
      patterns: [
        "Could you please...?",
        "Would it be possible to...?",
        "Can you help me with...?",
      ],
      video: {
        provider: "vimeo",
        id: "1194961794",
        ratio: "9:16",
      },
    },
    16: {
      title: "Say No Politely at Work",
      outcome: "You can decline requests professionally without sounding rude.",
      tamilOutcome:
        "நீங்கள் மரியாதையாகவும் தொழில்முறையாகவும் இல்லை என்று சொல்ல முடியும்.",
      patterns: [
        "I’m afraid I can’t...",
        "I won’t be able to...",
        "Maybe we can...",
      ],
      video: {
        provider: "vimeo",
        id: "1194961818",
        ratio: "9:16",
      },
    },
    17: {
      title: "Follow Up Smoothly",
      outcome: "You can follow up without sounding pushy.",
      tamilOutcome: "நீங்கள் அழுத்தமாக தோன்றாமல் மென்மையாக பின்தொடர முடியும்.",
      patterns: [
        "Just checking in...",
        "Gentle reminder...",
        "Any update on...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193308783",
        ratio: "9:16",
      },
    },
    18: {
      title: "Set Expectations Clearly",
      outcome: "You can avoid confusion by clearly aligning expectations.",
      tamilOutcome:
        "நீங்கள் எதிர்பார்ப்புகளை தெளிவுபடுத்தி குழப்பத்தை தவிர்க்க முடியும்.",
      patterns: [
        "I want to make sure...",
        "Let’s be aligned on...",
        "To clarify...",
      ],
      video: {
        provider: "vimeo",
        id: "1194961844",
        ratio: "9:16",
      },
    },
    19: {
      title: "Collaborate With Your Team",
      outcome: "You can discuss teamwork and divide tasks clearly.",
      tamilOutcome:
        "நீங்கள் குழுவுடன் வேலைப் பகிர்வு பற்றி தெளிவாக பேச முடியும்.",
      patterns: [
        "Let’s divide the work.",
        "I’ll handle...",
        "Can you take care of...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193308950",
        ratio: "9:16",
      },
    },
    20: {
      title: "Handle a Full Workday Conversation",
      outcome: "You can manage office conversations from morning to evening.",
      tamilOutcome:
        "நீங்கள் காலை முதல் மாலை வரை அலுவலக உரையாடல்களை நடத்த முடியும்.",
      patterns: ["Any update on...?", "I’m working on...", "Let’s divide..."],
      video: {
        provider: "vimeo",
        id: "1193308981",
        ratio: "9:16",
      },
    },
    21: {
      title: "Ask Better Follow-Up Questions",
      outcome:
        "You can continue conversations with natural follow-up questions.",
      tamilOutcome:
        "நீங்கள் இயல்பான follow-up கேள்விகளால் உரையாடலை தொடர முடியும்.",
      patterns: [
        "What happened next?",
        "How did you feel?",
        "What did you do then?",
      ],
      video: {
        provider: "vimeo",
        id: "1193465163",
        ratio: "9:16",
      },
    },
    22: {
      title: "Ask for Clarification Professionally",
      outcome: "You can ask someone to explain clearly when you feel confused.",
      tamilOutcome: "குழப்பமாக இருக்கும் போது தெளிவாக விளக்கச் சொல்ல முடியும்.",
      patterns: [
        "Could you clarify that?",
        "What do you mean by...?",
        "Can you explain that again?",
      ],
      video: {
        provider: "vimeo",
        id: "1193465181",
        ratio: "9:16",
      },
    },
    23: {
      title: "Ask Someone to Repeat or Slow Down",
      outcome: "You can handle fast English by asking politely.",
      tamilOutcome: "வேகமான ஆங்கிலத்தை மரியாதையாக கேட்டு சமாளிக்க முடியும்.",
      patterns: [
        "Could you repeat that?",
        "Could you say that again?",
        "Could you speak slowly?",
      ],
      video: {
        provider: "vimeo",
        id: "1193465200",
        ratio: "9:16",
      },
    },
    24: {
      title: "Confirm Your Understanding",
      outcome: "You can confirm meaning and avoid misunderstandings.",
      tamilOutcome:
        "நீங்கள் அர்த்தத்தை உறுதி செய்து ���வறான புரிதலை தவிர்க்க முடியும்.",
      patterns: ["So you mean...", "Just to confirm...", "Do you mean...?"],
      video: {
        provider: "vimeo",
        id: "1193465237",
        ratio: "9:16",
      },
    },
    25: {
      title: "Check Important Details",
      outcome:
        "You can ask for exact details like time, quantity, and deadline.",
      tamilOutcome:
        "நீங்கள் நேரம், அளவு, கடைசி தேதி போன்ற விவரங்களை தெளிவாக கேட்க முடியும்.",
      patterns: ["When exactly?", "How many...?", "By when...?"],
      video: {
        provider: "vimeo",
        id: "1193465279",
        ratio: "9:16",
      },
    },
    26: {
      title: "Ask Politely With Indirect Questions",
      outcome: "You can ask questions in a softer and more professional way.",
      tamilOutcome:
        "நீங்கள் கேள்விகளை மென்மையாகவும் தொழில்முறையாகவும் கேட்க முடியும்.",
      patterns: [
        "Could you tell me where...?",
        "Do you know if...?",
        "Can you let me know...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193465310",
        ratio: "9:16",
      },
    },
    27: {
      title: "Sound Conversational With Question Tags",
      outcome:
        "You can make your speech sound more natural and conversational.",
      tamilOutcome: "நீங்கள் உங்கள் பேச்சை இன்னும் இயல்பாக மாற்ற முடியும்.",
      patterns: ["Isn’t it?", "Don’t you?", "Right?"],
      video: {
        provider: "vimeo",
        id: "1193465348",
        ratio: "9:16",
      },
    },
    28: {
      title: "Respond Without Freezing",
      outcome: "You can buy thinking time and respond smoothly.",
      tamilOutcome:
        "நீங்கள் யோசிக்க நேரம் எடுத்து தடுமாறாமல் பதில் சொல்ல முடியும்.",
      patterns: [
        "Let me think...",
        "That’s a good question.",
        "Give me a second.",
      ],
      video: {
        provider: "vimeo",
        id: "1193465407",
        ratio: "9:16",
      },
    },
    29: {
      title: "Keep the Conversation Going",
      outcome: "You can extend conversations without awkward silence.",
      tamilOutcome: "நீங்கள் அமைதி ஏற்படாமல் உரையாடலை தொடர முடியும்.",
      patterns: ["That reminds me...", "Speaking of...", "By the way..."],
      video: {
        provider: "vimeo",
        id: "1193465408",
        ratio: "9:16",
      },
    },
    30: {
      title: "Handle a 5-Minute Q&A Conversation",
      outcome: "You can ask, answer, clarify, and follow up in a conversation.",
      tamilOutcome:
        "நீங்கள் கேட்டு, பதில் சொல்லி, தெளிவுபடுத்தி, follow-up செய்ய முடியும்.",
      patterns: [
        "Just to confirm...",
        "Could you clarify...?",
        "What happened next?",
      ],
      video: {
        provider: "vimeo",
        id: "1193465447",
        ratio: "9:16",
      },
    },
    31: {
      title: "Talk About Routines and Facts",
      outcome: "You can speak about daily habits and general truths clearly.",
      tamilOutcome:
        "நீங்கள் தினசரி பழக்கங்கள் மற்றும் பொதுவான உண்மைகள் பற்றி தெளிவாக பேச முடியும்.",
      patterns: ["I usually...", "I always...", "Every day, I..."],
      video: {
        provider: "vimeo",
        id: "1193468842",
        ratio: "9:16",
      },
    },
    32: {
      title: "Talk About Current Actions",
      outcome: "You can describe what is happening now.",
      tamilOutcome: "இப்போது என்ன நடக்கிறது என்பதை நீங்கள் விவரிக்க முடியும்.",
      patterns: [
        "I am currently...",
        "At the moment, I’m...",
        "We are working on...",
      ],
      video: {
        provider: "vimeo",
        id: "1193468881",
        ratio: "9:16",
      },
    },
    33: {
      title: "Use Daily and Now Correctly",
      outcome:
        "You can avoid common mistakes between routine and current action.",
      tamilOutcome:
        "நீங்கள் வழக்கம் மற்றும் இப்போதைய செயலை குழப்பாமல் பேச முடியும்.",
      patterns: ["I work every day.", "I am working now.", "Usually, I..."],
      video: {
        provider: "vimeo",
        id: "1193468900",
        ratio: "9:16",
      },
    },
    34: {
      title: "Talk About Completed Past Actions",
      outcome: "You can explain what happened yesterday or before.",
      tamilOutcome: "நேற்று அல்லது முன்பு நடந்ததை நீங்கள் விளக்க முடியும்.",
      patterns: ["Yesterday, I...", "I finished...", "I went to..."],
      video: {
        provider: "vimeo",
        id: "1193468957",
        ratio: "9:16",
      },
    },
    35: {
      title: "Describe What Was Happening",
      outcome: "You can describe background actions in the past.",
      tamilOutcome:
        "கடந்த காலத்தில் நடந்து கொண்டிருந்த செயல்களை நீங்கள் விவரிக்க முடியும்.",
      patterns: [
        "I was working...",
        "We were discussing...",
        "It was happening...",
      ],
      video: {
        provider: "vimeo",
        id: "1193468992",
        ratio: "9:16",
      },
    },
    36: {
      title: "Talk About Experience and Results",
      outcome: "You can speak about life experience and completed results.",
      tamilOutcome:
        "நீங்கள் அனுபவம் மற்றும் முடிந்த செயல்களின் விளைவு பற்றி பேச முடியும்.",
      patterns: [
        "I have worked...",
        "I have completed...",
        "I have already...",
      ],
      video: {
        provider: "vimeo",
        id: "1193469008",
        ratio: "9:16",
      },
    },
    37: {
      title: "Talk About Duration With Since and For",
      outcome: "You can explain how long something has been continuing.",
      tamilOutcome:
        "ஒரு செயல் எவ்வளவு காலமாக தொடர்கிறது w��ன்று நீங்கள் விளக்க முடியும்.",
      patterns: [
        "I have been working...",
        "Since 2020...",
        "For three years...",
      ],
      video: {
        provider: "vimeo",
        id: "1193469056",
        ratio: "9:16",
      },
    },
    38: {
      title: "Explain Earlier Past Actions",
      outcome: "You can explain what happened before another past action.",
      tamilOutcome:
        "கடந்த காலத்தில் இன்னொரு செயலுக்கு முன் நடந்ததை நீங்கள் விளக்க முடியும்.",
      patterns: [
        "I had finished...",
        "Before that, I had...",
        "By then, we had...",
      ],
      video: {
        provider: "vimeo",
        id: "1193469089",
        ratio: "9:16",
      },
    },
    39: {
      title: "Talk About the Future Clearly",
      outcome: "You can speak about plans, predictions, and possibilities.",
      tamilOutcome:
        "நீங்கள் திட்டங்கள், கணிப்புகள், வாய்ப்புகள் பற்றி தெளிவாde� பேச முடியும்.",
      patterns: ["I’m going to...", "I will...", "I might..."],
      video: {
        provider: "vimeo",
        id: "1193469100",
        ratio: "9:16",
      },
    },
    40: {
      title: "Switch Tenses Without Confusion",
      outcome:
        "You can talk about past, present, future, and experience clearly.",
      tamilOutcome:
        "நீங்கள் கடந்த காலம், நிகழ்காலம், எதிர்காலம், அனுபவம் பற்றி குழப்பமின்றி பேச முடியும்.",
      patterns: ["I usually...", "I have already...", "I’m going to..."],
      video: {
        provider: "vimeo",
        id: "1193469135",
        ratio: "9:16",
      },
    },
    41: {
      title: "Give a Strong Interview Intro",
      outcome: "You can answer “Tell me about yourself” with confidence.",
      tamilOutcome:
        "நீங்கள் நேர்காணலில் உங்களை நம்பிக்கையுடன் அறிமுகப்படுத்த முடியும்.",
      patterns: [
        "I’m currently...",
        "I have experience in...",
        "My key strengths are...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471497",
        ratio: "9:16",
      },
    },
    42: {
      title: "Explain Why You Want the Job",
      outcome: "You can explain your interest in a role clearly.",
      tamilOutcome:
        "நீங்கள் ஒரு வேலைக்கு ஏன் ஆர்வமாக இருக்கிறீர்கள் என்று தெளிவாக சொல்ல முடியும்.",
      patterns: [
        "I’m interested in this role because...",
        "This opportunity matches...",
        "I’m excited about...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471579",
        ratio: "9:16",
      },
    },
    43: {
      title: "Answer Strength Questions With Impact",
      outcome: "You can talk about your strengths with examples.",
      tamilOutcome: "நீங்கள் உங்கள் பலங்களை உதாரணங்களுடன் சொல்ல முடியும்.",
      patterns: [
        "One of my strengths is...",
        "For example...",
        "This helped me...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471618",
        ratio: "9:16",
      },
    },
    44: {
      title: "Handle Weakness Questions Smartly",
      outcome: "You can answer weakness questions honestly and professionally.",
      tamilOutcome:
        "நீங்கள் பலவீனம் பற்றிய கேள்விகளுக்கு நேர்மையாகவும் தொழில்முறையாகவும் பதில் சொல்ல முடியும்.",
      patterns: [
        "I’m working on...",
        "I’ve improved by...",
        "I’m trying to...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471700",
        ratio: "9:16",
      },
    },
    45: {
      title: "Tell a Professional Challenge Story",
      outcome: "You can explain a challenge using a clear story structure.",
      tamilOutcome: "நீங்கள் ஒரு சவாலை தெளிவான கதை அமைப்பில் விளக்க முடியும்.",
      patterns: [
        "The situation was...",
        "I took action by...",
        "The result was...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471686",
        ratio: "9:16",
      },
    },
    46: {
      title: "Explain Your Work History",
      outcome: "You can describe your past responsibilities and experience.",
      tamilOutcome:
        "நீங்கள் உங்கள் முந்தைய பொறுப்புகள் மற்றும் அனுபவத்தை விளக்க முடியும்.",
      patterns: [
        "I have handled...",
        "I was responsible for...",
        "I worked on...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471761",
        ratio: "9:16",
      },
    },
    47: {
      title: "Talk About Career Ambition",
      outcome: "You can explain your five-year career goals naturally.",
      tamilOutcome:
        "நீங்கள் உங்கள் ஐந்து ஆண்டு தொழில் இலக்குகளை இயல்பாக விளக்க முடியும்.",
      patterns: [
        "In five years...",
        "I see myself...",
        "I want to grow into...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471864",
        ratio: "9:16",
      },
    },
    48: {
      title: "Discuss Salary Politely",
      outcome: "You can talk about salary expectations in a professional way.",
      tamilOutcome: "நீங்கள் சம்பள எதிர்பார்ப்பை தொழில்முறையாக பேச முடியும்.",
      patterns: [
        "I was expecting...",
        "Based on my experience...",
        "I’m open to discussing...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471892",
        ratio: "9:16",
      },
    },
    49: {
      title: "Ask Smart Interview Questions",
      outcome: "You can ask useful questions at the end of an interview.",
      tamilOutcome:
        "நீங்கள் நேர்காணல் முடிவில் பயனுள்ள கேள்விகள் கேட்க முடியும்.",
      patterns: [
        "I’d like to know...",
        "Could you tell me more about...?",
        "What are the next steps?",
      ],
      video: {
        provider: "vimeo",
        id: "1193472044",
        ratio: "9:16",
      },
    },
    50: {
      title: "Complete a Mock Interview",
      outcome: "You can answer common interview questions confidently.",
      tamilOutcome:
        "நீங்கள் பொதுவான நேர்காணல் கேள்விகளுக்கு நம்பிக்கையுடன் பதில் சொல்ல முடியும்.",
      patterns: [
        "I’m currently...",
        "One of my strengths is...",
        "I’d like to know...",
      ],
      video: {
        provider: "vimeo",
        id: "1193471950",
        ratio: "9:16",
      },
    },
    51: {
      title: "Start a Meeting Confidently",
      outcome: "You can open a meeting and set the tone clearly.",
      tamilOutcome: "நீங்கள் கூட்டத்தை நம்பிக்கையுடன் தொடங்க முடியும்.",
      patterns: [
        "Shall we get started?",
        "Let’s begin with...",
        "Today, we’ll discuss...",
      ],
      video: {
        provider: "vimeo",
        id: "1193474832",
        ratio: "9:16",
      },
    },
    52: {
      title: "Share Quick Meeting Updates",
      outcome: "You can give short and clear updates in meetings.",
      tamilOutcome:
        "நீங்கள் கூட்டத்தில் சுருக்கமாகவும் தெளிவாகவும் அப்டேட் கொடுக்க முடியும்.",
      patterns: [
        "Here’s a quick update...",
        "I’ve completed...",
        "I’m currently working on...",
      ],
      video: {
        provider: "vimeo",
        id: "1193474879",
        ratio: "9:16",
      },
    },
    53: {
      title: "Agree and Add to Ideas",
      outcome: "You can agree and build on someone’s idea naturally.",
      tamilOutcome:
        "நீங்கள் ஒருவரின் யோசனையை ஏற்று அதில் மேலும் சேர்த்து பேச முடியும்.",
      patterns: [
        "I agree with...",
        "Building on that...",
        "That’s a good point...",
      ],
      video: {
        provider: "vimeo",
        id: "1193474922",
        ratio: "9:16",
      },
    },
    54: {
      title: "Disagree Respectfully",
      outcome: "You can share a different opinion without sounding rude.",
      tamilOutcome: "நீங்கள் மரியாதையாக வேறுபட்ட கருத்தை சொல்ல முடியும்.",
      patterns: [
        "I see your point, however...",
        "I understand, but...",
        "Maybe we can consider...",
      ],
      video: {
        provider: "vimeo",
        id: "1193475007",
        ratio: "9:16",
      },
    },
    55: {
      title: "Interrupt Politely in Discussions",
      outcome: "You can enter a discussion politely and confidently.",
      tamilOutcome: "நீங்கள் உரையாடலில் மரியாதையாக இடையில் பேச முடியும்.",
      patterns: [
        "Could I just add something?",
        "May I jump in?",
        "Can I share one point?",
      ],
      video: {
        provider: "vimeo",
        id: "1193475043",
        ratio: "9:16",
      },
    },
    56: {
      title: "Include Others in a Meeting",
      outcome:
        "You can ask for everyone’s opinion and encourage participation.",
      tamilOutcome:
        "நீங்கள் அனைவரின் கருத்தையும் கேட்டு கலந்துரையாடலை ஊக்குவிக்க முடியும்.",
      patterns: [
        "What does everyone think?",
        "Any thoughts on this?",
        "Would you like to add...?",
      ],
      video: {
        provider: "vimeo",
        id: "1193475169",
        ratio: "9:16",
      },
    },
    57: {
      title: "Summarise a Discussion Clearly",
      outcome: "You can recap key points at the end of a discussion.",
      tamilOutcome:
        "நீங்கள் கலந்துரையாடலின் முக்கிய அம்சங்களை தெளிவாக சுருக்க முடியும்.",
      patterns: ["To summarise...", "The key points are...", "We agreed to..."],
      video: {
        provider: "vimeo",
        id: "1193475168",
        ratio: "9:16",
      },
    },
    58: {
      title: "Present an Idea Clearly",
      outcome: "You can structure a short presentation with a clear flow.",
      tamilOutcome:
        "நீங்கள் ஒரு சிறிய விளக்க உரையை தெளிவான அமைப்பில் வழங்க முடியும்.",
      patterns: [
        "First, I’ll explain...",
        "The main point is...",
        "To conclude...",
      ],
      video: {
        provider: "vimeo",
        id: "1193475238",
        ratio: "9:16",
      },
    },
    59: {
      title: "Handle Q&A Confidently",
      outcome: "You can respond to questions during a presentation.",
      tamilOutcome:
        "நீங்கள் விளக்க உரையின் போது கேள்விகளுக்கு நம்பிக்கையுடன் பதில் சொல்ல முடியும்.",
      patterns: [
        "That’s a great question.",
        "Let me explain...",
        "To answer that...",
      ],
      video: {
        provider: "vimeo",
        id: "1193475280",
        ratio: "9:16",
      },
    },
    60: {
      title: "Present and Respond",
      outcome: "You can give a short presentation and handle basic Q&A.",
      tamilOutcome:
        "நீங்கள் சிறிய விளக்க உரை வழங்கி கேள்விகளுக்கு பதில் சொல்ல முடியும்.",
      patterns: [
        "First, I’ll explain...",
        "To summarise...",
        "That’s a great question.",
      ],
      video: {
        provider: "vimeo",
        id: "1193475352",
        ratio: "9:16",
      },
    },
    61: {
      title: "Start Emails Professionally",
      outcome: "You can open professional emails in a warm and clear way.",
      tamilOutcome: "நீங்கள் தொழில்முறை மின்னஞ்சலை மரியாதையாக தொடங்க முடியும்.",
      patterns: [
        "I hope you’re doing well.",
        "I’m writing to...",
        "Hope this finds you well.",
      ],
      video: {
        provider: "vimeo",
        id: "1193477139",
        ratio: "9:16",
      },
    },
    62: {
      title: "Write Clear Email Subject Lines",
      outcome:
        "You can write useful subject lines that show the purpose clearly.",
      tamilOutcome:
        "நீங்கள் நோக்கம் தெளிவாக தெரியும் subject lines எழுத முடியும்.",
      patterns: ["Update on...", "Request for...", "Follow-up on..."],
      video: {
        provider: "vimeo",
        id: "1193477162",
        ratio: "9:16",
      },
    },
    63: {
      title: "Make Requests by Email",
      outcome: "You can request information or action clearly by email.",
      tamilOutcome:
        "நீங்கள் மின்னஞ்சலில் தகவல் அல்லது செயலை தெளிவாக கேட்க முடியும்.",
      patterns: [
        "Could you please...?",
        "Would it be possible to...?",
        "Please let me know...",
      ],
      video: {
        provider: "vimeo",
        id: "1193477193",
        ratio: "9:16",
      },
    },
    64: {
      title: "Follow Up Politely by Email",
      outcome: "You can follow up without sounding impatient or rude.",
      tamilOutcome:
        "நீங்கள் அவசரப்படுத்துவது போல இல்லாமல் மரியாதையாக follow-up செய்ய முடியும்.",
      patterns: [
        "Just following up...",
        "Gentle reminder...",
        "When you get a chance...",
      ],
      video: {
        provider: "vimeo",
        id: "1193477213",
        ratio: "9:16",
      },
    },
    65: {
      title: "Decline Requests Professionally",
      outcome: "You can say no in emails politely and professionally.",
      tamilOutcome:
        "நீங்கள் மின்னஞ்சலில் மரியாதையாக இல்லை என்று சொல்ல முடியும்.",
      patterns: [
        "Unfortunately...",
        "I’m afraid we can’t...",
        "At this time...",
      ],
      video: {
        provider: "vimeo",
        id: "1193477243",
        ratio: "9:16",
      },
    },
    66: {
      title: "Write Professional Chat Messages",
      outcome: "You can write short and clear WhatsApp or Slack messages.",
      tamilOutcome:
        "நீங்கள் WhatsApp அல்லது Slack-ல் சுருக்கமான தெளிவான செய்திகளை எழுத முடியும்.",
      patterns: [
        "Quick update...",
        "Can you please...?",
        "Thanks for the update.",
      ],
      video: {
        provider: "vimeo",
        id: "1193477326",
        ratio: "9:16",
      },
    },
    67: {
      title: "Write Meeting Summaries",
      outcome: "You can send clear recaps with action items after meetings.",
      tamilOutcome:
        "நீங்கள் கூட்டத்திற்குப் பிறகு action items உடன் தெளிவான சுருக்கம் அனுப்ப முடியும்.",
      patterns: [
        "Here’s a quick recap...",
        "Action items are...",
        "Next steps are...",
      ],
      video: {
        provider: "vimeo",
        id: "1193477351",
        ratio: "9:16",
      },
    },
    68: {
      title: "Handle Professional Phone Calls",
      outcome: "You can open and close work calls politely.",
      tamilOutcome:
        "நீங்கள் வேலை தொடர்பான அழைப்புகள��� மரியாதையாக தொடங்கி முடிக்க முடியும்.",
      patterns: ["May I speak to...?", "This is...", "Thanks for your time."],
      video: {
        provider: "vimeo",
        id: "1193477383",
        ratio: "9:16",
      },
    },
    69: {
      title: "Handle Online Meetings",
      outcome: "You can manage common video meeting situations in English.",
      tamilOutcome:
        "நீங்கள் ஆன்லைன் கூட்டங்களில் பொதுவான சூழ்நிலைகளை ஆங்கிலத்தில் சமாளிக்க முடியும்.",
      patterns: [
        "Can you hear me?",
        "I’ll share my screen.",
        "You’re on mute.",
      ],
      video: {
        provider: "vimeo",
        id: "1193477418",
        ratio: "9:16",
      },
    },
    70: {
      title: "Communicate Across Channels",
      outcome: "You can handle email, chat, calls, and video meetings clearly.",
      tamilOutcome:
        "நீங்கள் email, chat, call, video meeting-ல் தெளிவாக தொடர்பு கொள்ள முடியும்.",
      patterns: ["Could you please...?", "Quick update...", "Can you hear me?"],
      video: {
        provider: "vimeo",
        id: "1193477496",
        ratio: "9:16",
      },
    },
    71: {
      title: "Express Basic Opinions",
      outcome: "You can share your opinion clearly in simple English.",
      tamilOutcome:
        "நீங்கள் உங்கள் கருத்தை எளிய ஆங்கிலத்தில் தெளிவாக சொல்ல முடியும்.",
      patterns: ["I think...", "I believe...", "In my opinion..."],
      video: {
        provider: "vimeo",
        id: "1194963418",
        ratio: "9:16",
      },
    },
    72: {
      title: "Share Mature Viewpoints",
      outcome: "You can express your viewpoint in a more mature way.",
      tamilOutcome:
        "நீங்கள் உங்கள் பார்வையை இன்னும் முதிர்ச்சியாக சொல்ல முடியும்.",
      patterns: [
        "From my perspective...",
        "The way I see it...",
        "In my view...",
      ],
      video: {
        provider: "vimeo",
        id: "1194963449",
        ratio: "9:16",
      },
    },
    73: {
      title: "Support Your Opinion With Reasons",
      outcome: "You can explain why you feel or think something.",
      tamilOutcome:
        "நீங்கள் ஏன் அப்படி நினைக்கிறீர்கள் என்பதை காரணத்துடன் விளக்க முடியும்.",
      patterns: ["Because...", "Since...", "The reason is..."],
      video: {
        provider: "vimeo",
        id: "1194963467",
        ratio: "9:16",
      },
    },
    74: {
      title: "Make Opinions Clearer With Examples",
      outcome:
        "You can use examples to make your opinion easier to understand.",
      tamilOutcome:
        "நீங்கள் உதாரணங்களால் உங்கள் கருத்தை தெளிவாக விளக்க முடியும்.",
      patterns: ["For example...", "For instance...", "A good example is..."],
      video: {
        provider: "vimeo",
        id: "1194963497",
        ratio: "9:16",
      },
    },
    75: {
      title: "Agree Naturally",
      outcome: "You can agree strongly or softly in a natural way.",
      tamilOutcome:
        "நீங்கள் இயல்பாக வலுவாகவும் மென்மையாகவும் சம்மதிக்க முடியும்.",
      patterns: ["Exactly.", "I completely agree.", "I agree to some extent."],
      video: {
        provider: "vimeo",
        id: "1194963529",
        ratio: "9:16",
      },
    },
    76: {
      title: "Disagree Without Offending",
      outcome: "You can disagree politely and respectfully.",
      tamilOutcome:
        "நீங்கள் மரியாதையாகவும் யாரையும் புண்படுத்தாமல் வேறுபட்ட கருத்தை சொல்ல முடியும்.",
      patterns: [
        "I see your point, but...",
        "I understand, however...",
        "I’m not sure about that.",
      ],
      video: {
        provider: "vimeo",
        id: "1194964889",
        ratio: "9:16",
      },
    },
    77: {
      title: "Discuss Both Sides",
      outcome: "You can compare two sides of an argument clearly.",
      tamilOutcome:
        "நீங்கள் ஒரு விஷயத்தின் இரு பக்கங்களையும் தெளிவாக விவாதிக்க முடியும்.",
      patterns: [
        "On the other hand...",
        "Having said that...",
        "Another point is...",
      ],
      video: {
        provider: "vimeo",
        id: "1194964907",
        ratio: "9:16",
      },
    },
    78: {
      title: "Give Nuanced Opinions",
      outcome:
        "You can avoid black-and-white answers and speak more thoughtfully.",
      tamilOutcome:
        "நீங்கள் ஒரே மாதிரி பதில்கள் இல்லாமல் சிந்தித்து கருத்து சொல்ல முடியும்.",
      patterns: ["It depends.", "In some cases...", "It depends on..."],
      video: {
        provider: "vimeo",
        id: "1194964937",
        ratio: "9:16",
      },
    },
    79: {
      title: "Discuss Possibilities With If",
      outcome: "You can talk about possible results using simple conditionals.",
      tamilOutcome:
        "நீங்கள் if பயன்படுத்தி சாத்தியமான முடிவுகளைப் பற்றி பேச முடியும்.",
      patterns: ["If we do this...", "If this happens...", "We can..."],
      video: {
        provider: "vimeo",
        id: "1194964960",
        ratio: "9:16",
      },
    },
    80: {
      title: "Give a 3-Point Opinion Talk",
      outcome: "You can give an opinion with reasons and examples.",
      tamilOutcome:
        "நீங்கள் காரணங்கள் மற்றும் உதாரணங்களுடன் உங்கள் கருத்தை சொல்ல முடியும்.",
      patterns: ["In my opinion...", "The reason is...", "For example..."],
      video: {
        provider: "vimeo",
        id: "1194964969",
        ratio: "9:16",
      },
    },
    81: {
      title: "Understand Good Story Flow",
      outcome:
        "You can organize a story with a clear beginning, middle, and end.",
      tamilOutcome:
        "நீங்கள் கதையை தொடக்கம், நடுப்பு, முடிவு என தெளிவாக அமைக்க முடியும்.",
      patterns: ["At the beginning...", "In the middle...", "In the end..."],
      video: {
        provider: "vimeo",
        id: "1194996382",
        ratio: "9:16",
      },
    },
    82: {
      title: "Start a Story Naturally",
      outcome: "You can begin a story in a natural and interesting way.",
      tamilOutcome: "நீங்கள் கதையை இயல்பாகவும் ஆர்வமாகவும் தொடங்க முடியும்.",
      patterns: [
        "So what happened was...",
        "Let me tell you what happened.",
        "It all started when...",
      ],
      video: {
        provider: "vimeo",
        id: "1194996419",
        ratio: "9:16",
      },
    },
    83: {
      title: "Set the Scene Clearly",
      outcome: "You can give context before telling the main event.",
      tamilOutcome:
        "முக்கிய நிகழ்வுக்கு முன் சூழ்நிலையை நீங்கள் தெளிவாக சொல்ல முடி  �ும்.",
      patterns: [
        "It was a Monday morning...",
        "I was at...",
        "We were getting ready to...",
      ],
      video: {
        provider: "vimeo",
        id: "1194996469",
        ratio: "9:16",
      },
    },
    84: {
      title: "Make Stories More Engaging",
      outcome: "You can build tension and make your story more interesting.",
      tamilOutcome: "நீங்கள் கதையை இன்னும் சுவாரஸ்யமாக சொல்ல முடியும்.",
      patterns: ["Suddenly...", "Out of nowhere...", "At that moment..."],
      video: {
        provider: "vimeo",
        id: "1194996515",
        ratio: "9:16",
      },
    },
    85: {
      title: "Explain Past Sequence in Stories",
      outcome: "You can show what happened before another past event.",
      tamilOutcome:
        "கடந்த நிகழ்வுக்கு முன் நடந்ததை நீங்கள் கதையில் விளக்க முடியும்.",
      patterns: ["I had already...", "Before that, I had...", "By the time..."],
      video: {
        provider: "vimeo",
        id: "1194996674",
        ratio: "9:16",
      },
    },
    86: {
      title: "Keep Your Story Flowing",
      outcome: "You can connect story events smoothly using time connectors.",
      tamilOutcome:
        "நீங்கள் நேர இணைப்புச் சொற்களால் கதையை தொடர்ச்சியாக சொல்ல முடியும்.",
      patterns: ["Then...", "After that...", "Meanwhile..."],
      video: {
        provider: "vimeo",
        id: "1195066295",
        ratio: "9:16",
      },
    },
    87: {
      title: "Add Emotion and Personality",
      outcome: "You can make stories memorable by adding feelings.",
      tamilOutcome:
        "நீங்கள் உணர்வுகளை சேர்த்து கதையை நினைவில் நிற்கும் வகையில் சொல்ல முடியும்.",
      patterns: [
        "I was shocked.",
        "I felt relieved.",
        "I couldn’t believe it.",
      ],
      video: {
        provider: "vimeo",
        id: "1195066290",
        ratio: "9:16",
      },
    },
    88: {
      title: "Report What People Said",
      outcome: "You can include what others said in your story.",
      tamilOutcome:
        "நீங்கள் கதையில் மற்றவர்கள் சொன்னதை சேர்த்து சொல்ல முடியும்.",
      patterns: ["He said...", "She told me...", "They asked me..."],
      video: {
        provider: "vimeo",
        id: "1195066308",
        ratio: "9:16",
      },
    },
    89: {
      title: "Tell a Professional Challenge Story",
      outcome: "You can tell a work challenge story with structure and impact.",
      tamilOutcome:
        "நீங்கள் வேலை சவால் கதையை அமைப்புடனும் தாக்கத்துடனும் சொல்ல முடியும்.",
      patterns: [
        "The situation was...",
        "I took action by...",
        "The result was...",
      ],
      video: {
        provider: "vimeo",
        id: "1195066337",
        ratio: "9:16",
      },
    },
    90: {
      title: "Tell a Full 3-Minute Story",
      outcome: "You can tell a complete story with flow, emotion, and clarity.",
      tamilOutcome:
        "நீங்கள் ஓட்டம், உணர்வு, தெளிவுடன் முழு கதையை சொல்ல முடியும்.",
      patterns: ["It all started when...", "Suddenly...", "In the end..."],
      video: {
        provider: "vimeo",
        id: "1195066340",
        ratio: "9:16",
      },
    },
    91: {
      title: "Explain a Problem Clearly",
      outcome: "You can identify and explain a problem in a clear way.",
      tamilOutcome:
        "நீங்கள் ஒரு பிரச்சனையை தெளிவாக அடையாளம் கண்டு விளக்க முடியும்.",
      patterns: ["The issue is...", "The problem is...", "We are facing..."],
      video: {
        provider: "vimeo",
        id: "1195066904",
        ratio: "9:16",
      },
    },
    92: {
      title: "Explain the Cause",
      outcome: "You can explain why a problem happened.",
      tamilOutcome: "ஒரு பிரச்சனை ஏன் நடந்தது என்று நீங்கள் விளக்க முடியும்.",
      patterns: [
        "It happened because...",
        "The reason is...",
        "This was caused by...",
      ],
      video: {
        provider: "vimeo",
        id: "1195066910",
        ratio: "9:16",
      },
    },
    93: {
      title: "Offer Practical Solutions",
      outcome: "You can suggest solutions in a professional way.",
      tamilOutcome: "நீங்கள் தொழில்முறையாக தீர்வுகளை பரிந்துரைக்க முடியும்.",
      patterns: ["I suggest...", "What if we...?", "We could try..."],
      video: {
        provider: "vimeo",
        id: "1195066917",
        ratio: "9:16",
      },
    },
    94: {
      title: "Ask for More Time",
      outcome: "You can request a deadline extension politely.",
      tamilOutcome: "நீங்கள் காலக்கெடு நீட்டிப்பை மரியாதையாக கேட்க முடியும்.",
      patterns: [
        "Could we extend the deadline?",
        "Can we get more time?",
        "Would it be possible to...?",
      ],
      video: {
        provider: "vimeo",
        id: "1195066941",
        ratio: "9:16",
      },
    },
    95: {
      title: "Set Realistic Expectations",
      outcome: "You can explain limits and timelines honestly.",
      tamilOutcome:
        "நீங்கள் வரம்புகள் மற்றும் காலஅளவை நேர்மையாக விளக்க முடியும்.",
      patterns: [
        "I want to be transparent...",
        "Realistically...",
        "To set expectations...",
      ],
      video: {
        provider: "vimeo",
        id: "1195066947",
        ratio: "9:16",
      },
    },
    96: {
      title: "Handle Complaints Calmly",
      outcome: "You can respond to complaints in a calm and professional way.",
      tamilOutcome:
        "நீங்கள் புகார்களுக்கு அமைதியாகவும் தொழில்முறையாகவும் பதில் சொல்ல முடியும்.",
      patterns: [
        "I understand your concern.",
        "I’m sorry about that.",
        "Let me check this...",
      ],
      video: {
        provider: "vimeo",
        id: "1195067401",
        ratio: "9:16",
      },
    },
    97: {
      title: "Push Back Politely",
      outcome: "You can disagree constructively without creating tension.",
      tamilOutcome:
        "நீங்கள் பதற்றம் இல்லாமல் கட்டுமானமாக வேறுபட்ட கருத்தை சொல்ல முடியும்.",
      patterns: [
        "Could we look at this differently?",
        "I see your point, but...",
        "Another option is...",
      ],
      video: {
        provider: "vimeo",
        id: "1195067412",
        ratio: "9:16",
      },
    },
    98: {
      title: "Deliver Bad News Professionally",
      outcome: "You can share difficult news with care and clarity.",
      tamilOutcome:
        "நீங்கள் கடினமான செய்தியை கவனமாகவும் தெளிவாகவும் சொல்ல முடியும்.",
      patterns: [
        "I’m afraid there’s an issue.",
        "Unfortunately...",
        "I wanted to let you know...",
      ],
      video: {
        provider: "vimeo",
        id: "1195130913",
        ratio: "9:16",
      },
    },
    99: {
      title: "Explain Issues Professionally",
      outcome: "You can use passive voice to explain problems professionally.",
      tamilOutcome:
        "நீங்கள் passive voice பயன்படுத்தி பிரச்சனைகளை தொழில்முறையாக விளக்க முடியும்.",
      patterns: [
        "It was delayed.",
        "It has been fixed.",
        "It is being checked.",
      ],
      video: {
        provider: "vimeo",
        id: "1195130950",
        ratio: "9:16",
      },
    },
    100: {
      title: "Solve Problems Through Roleplay",
      outcome: "You can explain an issue, give reasons, and offer solutions.",
      tamilOutcome:
        "நீங்கள் பிரச்சனையை விளக்கி, காரணம் சொல்லி, தீர்வு வழங்க முடியும்.",
      patterns: ["The issue is...", "It happened because...", "I suggest..."],
      video: {
        provider: "vimeo",
        id: "1195130974",
        ratio: "9:16",
      },
    },
    101: {
      title: "Sound Natural With Contractions",
      outcome: "You can use common short forms in daily speaking.",
      tamilOutcome:
        "நீங்கள் தினசரி பேச்சில் பொதுவான சுருக்க வடிவங்களை பயன்படுத்த முடியும்.",
      patterns: ["I’m...", "I’ve...", "I’ll..."],
      video: {
        provider: "vimeo",
        id: "1195131815",
        ratio: "9:16",
      },
    },
    102: {
      title: "Speak Smoothly With Natural Fillers",
      outcome: "You can use simple fillers to speak more smoothly.",
      tamilOutcome: "நீங்கள் எளிய fillers பயன்படுத்தி மென்மையாக பேச முடியும்.",
      patterns: ["Well...", "So...", "Actually..."],
      video: {
        provider: "vimeo",
        id: "1195131834",
        ratio: "9:16",
      },
    },
    103: {
      title: "Think Out Loud Without Freezing",
      outcome: "You can avoid silence while thinking during a conversation.",
      tamilOutcome:
        "நீங்கள் யோசிக்கும் போது அமைதியாக நின்றுவிடாமல் பேச முடியும்.",
      patterns: [
        "Let me think...",
        "How do I put this?",
        "Give me a second...",
      ],
      video: {
        provider: "vimeo",
        id: "1195131865",
        ratio: "9:16",
      },
    },
    104: {
      title: "Restart and Self-Correct Smoothly",
      outcome: "You can correct your sentence naturally while speaking.",
      tamilOutcome:
        "நீங்கள் பேசும்போது உங்கள் வாக்கியத்தை இயல்பாக திருத்த முடியும்.",
      patterns: ["What I mean is...", "Let me rephrase...", "I mean..."],
      video: {
        provider: "vimeo",
        id: "1195131915",
        ratio: "9:16",
      },
    },
    105: {
      title: "Sound Less Harsh",
      outcome: "You can soften your speech and sound more polite.",
      tamilOutcome:
        "நீங்கள் உங்கள் பேச்சை மென்மையாகவும் மரியாதையாகவும் மாற்ற முடியும்.",
      patterns: ["Kind of...", "Sort of...", "A bit..."],
      video: {
        provider: "vimeo",
        id: "1195131922",
        ratio: "9:16",
      },
    },
    106: {
      title: "Sound Natural and Polite",
      outcome: "You can express ideas in a softer and more balanced way.",
      tamilOutcome:
        "நீங்கள் கருத்துகளை மென்மையாகவும் சமநிலையுடனும் சொல்ல முடியும்.",
      patterns: ["To be fair...", "Honestly...", "In a way..."],
      video: {
        provider: "vimeo",
        id: "1195134643",
        ratio: "9:16",
      },
    },
    107: {
      title: "React Naturally in Conversations",
      outcome: "You can respond naturally when someone speaks to you.",
      tamilOutcome: "யாராவது பேசும்போது நீங்கள் இயல்பாக பதில் சொல்ல முடியும்.",
      patterns: ["That makes sense.", "Fair enough.", "I see what you mean."],
      video: {
        provider: "vimeo",
        id: "1195134659",
        ratio: "9:16",
      },
    },
    108: {
      title: "Understand Common Phrasal Verbs",
      outcome: "You can use common phrasal verbs in daily work conversations.",
      tamilOutcome:
        "நீங்கள் தினசரி வேலை உரையாடலில் பொதுவான phrasal verbs பயன்படுத்த முடியும்.",
      patterns: ["Get back to...", "Follow up on...", "Look into..."],
      video: {
        provider: "vimeo",
        id: "1195134713",
        ratio: "9:16",
      },
    },
    109: {
      title: "Fix Common Indian English Mistakes",
      outcome: "You can avoid common errors and speak more natural English.",
      tamilOutcome:
        "நீங்கள் பொதுவான தவறுகளை தவிர்த்து இயல்பான ஆங்கிலத்தில் பேச முடியும்.",
      patterns: ["Discuss...", "Reply to...", "Move forward..."],
      video: {
        provider: "vimeo",
        id: "1195134752",
        ratio: "9:16",
      },
    },
    110: {
      title: "Speak Without Sounding Robotic",
      outcome: "You can have a natural 5-minute conversation with better flow.",
      tamilOutcome:
        "நீங்கள் நல்ல ஓட்டத்துடன் இயல்பான 5 நிமிட உரையாடல் பேச முடியும்.",
      patterns: ["Well...", "What I mean is...", "That makes sense."],
      video: {
        provider: "vimeo",
        id: "1195134774",
        ratio: "9:16",
      },
    },
    111: {
      title: "Master Your Professional Introduction",
      outcome:
        "You can give a polished professional introduction with confidence.",
      tamilOutcome:
        "நீங்கள் நம்பிக்கையுடன் தொழில்முறை சுய அறிமுகம் கொடுக்க முடியும்.",
      patterns: ["I’m currently...", "I’m responsible for...", "My goal is..."],
      video: {
        provider: "vimeo",
        id: "1195135681",
        ratio: "9:16",
      },
    },
    112: {
      title: "Handle Daily Office Conversations",
      outcome: "You can manage common workplace conversations naturally.",
      tamilOutcome: "நீங்கள் தினசரி அலுவலக உரையாடல்களை இயல்பாக நடத்த முடியும்.",
      patterns: [
        "Any update on...?",
        "I’m working on...",
        "Could you please...?",
      ],
      video: {
        provider: "vimeo",
        id: "1195135712",
        ratio: "9:16",
      },
    },
    113: {
      title: "Master Tense Switching",
      outcome:
        "You can talk about past, present, future, experience, and duration clearly.",
      tamilOutcome: "நீங்கள் காலங்களை குழப்பமின்றி தெளிவாக பேச முடியும்.",
      patterns: ["I worked...", "I’m working...", "I’ve been working..."],
      video: {
        provider: "vimeo",
        id: "1195135750",
        ratio: "9:16",
      },
    },
    114: {
      title: "Complete an Interview Simulation",
      outcome: "You can answer key interview questions confidently.",
      tamilOutcome:
        "நீங்கள் முக்கிய நேர்காணல் கேள்விகளுக்கு நம்பிக்கையுடன் பதில் சொல்ல முடியும்.",
      patterns: [
        "Tell me about yourself.",
        "One of my strengths is...",
        "I’m looking for...",
      ],
      video: {
        provider: "vimeo",
        id: "1195135783",
        ratio: "9:16",
      },
    },
    115: {
      title: "Participate in a Meeting",
      outcome: "You can share updates, opinions, and questions in a meeting.",
      tamilOutcome:
        "நீங்கள் கூட்டத்தில் அப்டேட், கருத்து, கேள்விகளை பகிர முடியும்.",
      patterns: [
        "Here’s a quick update...",
        "I agree with...",
        "Could I add something?",
      ],
      video: {
        provider: "vimeo",
        id: "1195135810",
        ratio: "9:16",
      },
    },
    116: {
      title: "Communicate Across Channels",
      outcome: "You can handle email, chat, phone calls, and online meetings.",
      tamilOutcome:
        "நீங்கள் email, chat, phone call, online meeting-ல் தெளிவாக தொடர்பு கொள்ள முடியும்.",
      patterns: [
        "Could you please...?",
        "Just following up...",
        "Can you hear me?",
      ],
      video: {
        provider: "vimeo",
        id: "1195137059",
        ratio: "9:16",
      },
    },
    117: {
      title: "Discuss Opinions With Reasons",
      outcome: "You can discuss a topic with reasons, examples, and balance.",
      tamilOutcome:
        "நீங்கள் காரணங்கள், உதாரணங்கள், சமநிலையுடன் ஒரு தலைப்பை விவாதிக்க முடியும்.",
      patterns: ["In my opinion...", "The reason is...", "For example..."],
      video: {
        provider: "vimeo",
        id: "1195137087",
        ratio: "9:16",
      },
    },
    118: {
      title: "Tell a Personal or Professional Story",
      outcome: "You can tell a clear story with flow, emotion, and structure.",
      tamilOutcome:
        "நீங்கள் ஓட்டம், உணர்வு, அமைப்புடன் தெளிவான கதையை சொல்ல முடியும்.",
      patterns: ["It all started when...", "Suddenly...", "In the end..."],
      video: {
        provider: "vimeo",
        id: "1195137131",
        ratio: "9:16",
      },
    },
    119: {
      title: "Solve Problems Through Conversation",
      outcome: "You can explain an issue and propose a practical solution.",
      tamilOutcome:
        "நீங்கள் பிரச்சனையை விளக்கி நடைமுறை தீர்வை முன்மொழிய முடியும்.",
      patterns: ["The issue is...", "It happened because...", "I suggest..."],
      video: {
        provider: "vimeo",
        id: "1195137148",
        ratio: "9:16",
      },
    },
    120: {
      title: "Give a 5-Minute Unscripted Talk",
      outcome: "You can speak freely and measure your fluency growth.",
      tamilOutcome:
        "நீங்கள் சுதந்திரமாக பேசி உங்கள் fluency வளர்ச்சியை மதிப்பிட முடியும்.",
      patterns: [
        "I’d like to talk about...",
        "One important point is...",
        "To conclude...",
      ],
      video: {
        provider: "vimeo",
        id: "1195137198",
        ratio: "9:16",
      },
    },
  },
};
